<template>
  <div>
    <div class="row mb-4 d-none d-md-block">
      <div class="col-12">
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item ml-3 ml-md-0" role="presentation"><a
              class="nav-link h4 text-gray-50 font-weight-light active" id="data-nav-tab" data-toggle="tab"
              href="#data-tab-pane" role="tab" aria-controls="data-tab-pane" aria-selected="true">{{
              __('lang.global.product.tabs.techdata')}}</a></li>
          <!-- <li v-if="product_media.length > 0"
            :class="product_data.flag_fan == 1 ? 'nav-item ml-md-3': 'nav-link h4 text-gray-50 font-weight-light active'"
            role="presentation"><a class="nav-link h4 text-gray-50 font-weight-light" id="downloads-nav-tab"
              data-toggle="tab" href="#downloads-tab-pane" role="tab" aria-controls="downloads-tab-pane"
              :aria-selected="isActive" @click="getProductDownloads">{{
              __('lang.global.product.downloads')}}</a></li> -->
          <li v-show="product_media.length > 0" class="nav-item ml-md-3" role="presentation"><a
              class="nav-link h4 text-gray-50 font-weight-light" id="downloads-nav-tab" data-toggle="tab"
              href="#downloads-tab-pane" role="tab" aria-controls="downloads-tab-pane" :aria-selected="isActive"
              @click="getProductDownloads">{{
              __('lang.global.product.downloads')}}</a></li>
          <li v-show="product_data.flag_fan==1 && product_data.curvenexists" class="nav-item ml-md-3" role="presentation"><a
              class="nav-link h4 text-gray-50 font-weight-light" id="characteristics-nav-tab" data-toggle="tab"
              href="#characteristics-tab-pane" role="tab" aria-controls="characteristics-tab-pane" aria-selected="false"
              @click="getProductCurves" ref="prodcurves">{{ __('lang.global.product.tabs.curves')}}</a></li>
          <li v-show="media_ssplan!=''" class="nav-item ml-md-3" role="presentation"><a
              class="nav-link h4 text-gray-50 font-weight-light" id="diagram-nav-tab" data-toggle="tab"
              href="#diagram-tab-pane" role="tab" aria-controls="diagram-tab-pane" aria-selected="false">{{
              __('lang.global.product.tabs.ssplan')}}</a></li>
          <!-- <li v-if="media_dimension.length > 0" class="nav-item ml-md-3" role="presentation"><a class="nav-link h4 text-gray-50 font-weight-light" id="dimensions-nav-tab" data-toggle="tab" href="#dimensions-tab-pane" role="tab" aria-controls="dimensions-tab-pane" aria-selected="false">{{ __('lang.global.product.downloads.dimension')}}</a></li> -->
          <li v-show ="media_lvtext!=''" class="nav-item ml-md-3" role="presentation">
              <a class="nav-link h4 text-gray-50 font-weight-light" id="lv-nav-tab" data-toggle="tab" href="#lv-tab-pane" role="tab" aria-controls="lv-tab-pane" aria-selected="false">
                  {{ __('lang.global.product.tabs.lvtext')}}</a>
          </li>
          <li v-show="accessories.length > 0" class="nav-item ml-md-3" role="presentation"><a
              class="nav-link h4 text-gray-50 font-weight-light" id="equipment-nav-tab" data-toggle="tab"
              href="#equipment-tab-pane" role="tab" aria-controls="equipment-tab-pane" aria-selected="false"
              @click="getProductAccessories">{{ __('lang.global.product.tabs.accessories')}}</a></li>
          <li  v-show="product_data.flag_fan==2 && product_data.parentsexists"  class="nav-item ml-md-3" role="presentation"><a
                  class="nav-link h4 text-gray-50 font-weight-light" id="parents-nav-tab" data-toggle="tab"
                  href="#parents-tab-pane" role="tab" aria-controls="parents-tab-pane" aria-selected="false"
                  @click="getProductParents">{{ __('lang.global.product.tabs.suitable')}}</a></li>
            <!--<li v-if="user.auth" class="nav-item ml-md-3" role="presentation"><a
                             class="nav-link h4 text-gray-50 font-weight-light" id="cadenas-nav-tab" data-toggle="tab"
                             href="#cadenas-tab-pane" role="tab" aria-controls="cadenas-tab-pane" aria-selected="false"
                             @click="loadIframeCadenas()">{{ __('lang.global.product.tabs.cadenas') }}</a></li>
              <li v-else class="nav-item ml-md-3" role="presentation">
                             <p class="h4 text-gray-50 font-weight-light" style="display: block; padding: .5rem 1rem 0rem 1rem !important;">{{ __('lang.global.product.tabs.cadenas') }}
                               <span class="p-0 small text-gray-50 font-weight-light text-center" style="font-size:.8rem">{{ __('lang.message.loginrequired') }}</span>
                             </p>
                            </li>--><!-- @click="openloginframe" -->
        </ul>
      </div>
    </div>


    <div class="row mb-5 d-none d-md-block">
      <div class="col-12">
        <div class="tab-content">
          <!--  <div :class="product_data.flag_fan==1 ? 'tab-pane active': 'tab-pane'" id="data-tab-pane"> -->
          <div class="tab-pane active" id="data-tab-pane">
            <div class="row">
              <div class="col-12 col-lg-8">
                <h5 class="mb-3">{{ __('lang.global.product.tabs.techdata.info')}}</h5>

                <b-table :items="productitems" :fields="table_fields_techproperties" stacked striped  class="techdata table-sm">
                  <template v-slot:cell(explosionproof)="{item}">
                    <svg class="icon" v-if="item.explosionproof == 1">
                      <use xlink:href="/assets/img/icon-sprite.svg#global.check" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                    </svg>
                    <!--  <b-img v-bind="checkprops" rounded="circle" alt="yes"></b-img> -->
                  </template>
                  <template v-slot:cell(ec_technology)="{item}">
                    <svg class="icon" v-if="item.ec_technology == 1">
                      <use xlink:href="/assets/img/icon-sprite.svg#global.check" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                    </svg>
                  </template>
                  <template v-slot:cell(lining)="{item}">
                    <svg class="icon" v-if="item.lining == 1">
                      <use xlink:href="/assets/img/icon-sprite.svg#global.check" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                    </svg>
                  </template>
                  <template v-slot:cell(hotair_upto120)="{item}">
                    <svg class="icon" v-if="item.hotair_upto120 == 1">
                      <use xlink:href="/assets/img/icon-sprite.svg#global.check" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                    </svg>
                  </template>
                </b-table>

<!-- <table class="table table-sm table-striped table-borderless mb-3">
  <tbody>
    <tr>
      <th class="small border-right align-middle" scope="row">{{
        __('lang.global.product.tabs.techdata.refno')}}</th>
      <td>{{product_data.ref_no}} - {{product_data.version}}</td>
    </tr>
    <tr>
      <th class="small border-right align-middle" scope="row">{{
        __('lang.global.product.tabs.techdata.type')}}</th>
      <td>{{product_data.type}}</td>
    </tr>
    <tr>
      <th class="small border-right align-middle" scope="row">{{
        __('lang.global.product.tabs.techdata.desc_short')}}</th>
      <td>{{product_data.description_short}}</td>
    </tr>
                   <tr v-if="parseFloat(op.pressure)>0">
                      <th class="small border-right align-middle" scope="row">{{
                        __('lang.global.product.tabs.techdata.pressure_actual')}}</th>
                      <td>{{op.pressure}} {{units_selected.pressureunits}} {{ __('lang.externalpressuretyp.'+
                        op.pressuretype)}} </td>
                    </tr>
                    <tr v-if="parseFloat(op.airflow)>0">
                      <th class="small border-right align-middle" scope="row">{{
                        __('lang.global.product.tabs.techdata.airflow_actual')}}</th>
                      <td>{{op.airflow}} {{units_selected.airflowunits}}</td>
                    </tr>
    <tr v-if="product_data.flag_fan==1">
      <th class="small border-right align-middle" scope="row">{{
        __('lang.global.product.tabs.techdata.airflow_max')}}</th>
      <td>{{product_data.max_volumeflow}} {{ __('lang.units.airflow_volume') }}</td>
    </tr>
    <tr v-if="product_data.flag_fan==1">
      <th class="small border-right align-middle" scope="row">{{
        __('lang.global.product.tabs.techdata.pressure_max')}}</th>
      <td>{{product_data.max_pressure}} {{ __('lang.units.pascal') }}</td>
    </tr>
    <tr v-if="product_data.flag_fan==1">
      <th class="small border-right align-middle" scope="row">{{
        __('lang.global.product.tabs.techdata.rpm')}}</th>
      <td>{{product_data.rpm1}}<span v-if="parseFloat(product_data.rpm2)>0"> /
          {{product_data.rpm2}}</span> {{ __('lang.units.rpm') }}</td>
    </tr>
    <tr v-if="product_data.flag_fan==1">
      <th class="small border-right align-middle" scope="row">{{
        __('lang.global.product.tabs.techdata.flc_uncontrolled')}}</th>
      <td>{{product_data.flc_uncontrolled1}}<span v-if="parseFloat(product_data.flc_uncontrolled2)>0"> /
          {{product_data.flc_uncontrolled2}}</span> {{ __('lang.units.amper') }}</td>
    </tr>
    <tr v-if="product_data.flag_fan==1">
      <th class="small border-right align-middle" scope="row">{{
        __('lang.global.product.tabs.techdata.stc_uncontrolled')}}</th>
      <td><span v-if="parseFloat(product_data.stc_uncontrolled)>0">{{product_data.stc_uncontrolled}} {{
          __('lang.units.amper') }}</span></td>
    </tr>
    <tr v-if="product_data.flag_fan==1">
      <th class="small border-right align-middle" scope="row">{{
        __('lang.global.product.tabs.techdata.power')}}</th>
      <td>{{parseFloat(product_data.power1/1000).toFixed(2)}}<span v-if="parseFloat(product_data.power2)>0"> /
          {{parseFloat(product_data.power2/1000).toFixed(2)}}</span> {{ __('lang.units.kilowatt') }}</td>
    </tr>
    <tr v-if="product_data.flag_fan==1">
      <th class="small border-right align-middle" scope="row">{{
        __('lang.global.product.tabs.techdata.voltage')}}</th>
      <td>{{voltage}}</td>
    </tr>
    <tr v-if="product_data.flag_fan==1">
      <th class="small border-right align-middle" scope="row">{{
        __('lang.global.product.tabs.techdata.protectionclass')}}</th>
      <td>{{product_data.protectionclass}}</td>
    </tr>
    <tr v-if="product_data.flag_fan==1">
      <th class="small border-right align-middle" scope="row">{{
        __('lang.global.product.tabs.techdata.temp_max')}}</th>
      <td>{{max_temp}} {{ __('lang.units.degree') }}<br>
      </td>
    </tr>
    <tr>
      <th class="small border-right align-middle" scope="row">{{
        __('lang.global.product.tabs.techdata.ssplan_no')}}</th>
      <td>{{product_data.ss_nr}}</td>
    </tr>
    <tr>
      <th class="small border-right align-middle" scope="row">{{
        __('lang.global.product.tabs.techdata.weight')}}</th>
      <td>{{product_data.weight}} {{ __('lang.units.kilo') }}</td>
    </tr>
    <tr>
      <th class="small border-right" scope="row">{{ __('lang.global.product.tabs.techdata.delivery')}}
      </th>
      <td><span v-if="parseFloat(product_data.delivery)>0">{{product_data.delivery}}
          {{__('lang.units.week')}}</span>
        <span v-else>{{__('lang.global.onrequest')}}</span>
      </td>
    </tr>
  </tbody>
</table> -->



                  <h5 class="mb-3" v-show="product_data.flag_fan == 1 && ( soundinduct.lwa > 0 || casebreakout.lwa > 0)">
                  {{
                  __('lang.global.product.tabs.techdata.acousticdata')}}</h5>

                <table v-show="product_data.flag_fan == 1 && (soundinduct.lwa > 0 || casebreakout.lwa > 0)"
                  class="table table-sm table-striped table-borderless mb-3">
                  <tbody>
                    <tr v-show="soundinduct.lwa > 0">
                      <th class="small border-right align-middle" scope="row">{{
                      __('lang.global.product.tabs.techdata.soundinduct')}}</th>
                      <td>{{soundinduct.lwa}} {{ __('lang.global.product.tabs.techdata.acoustic.dba') }}
                        {{ __('lang.global.product.tabs.techdata.acoustic.in') }}
                        {{soundinduct.distance }}
                        {{__('lang.units.meter') }}</td>
                    </tr>
                    <tr v-show="casebreakout.lwa > 0">
                      <th class="small border-right align-middle" scope="row">{{
                      __('lang.global.product.tabs.techdata.casebreakout')}}</th>
                      <td>{{casebreakout.lwa}} {{ __('lang.global.product.tabs.techdata.acoustic.dba') }}
                        {{__('lang.global.product.tabs.techdata.acoustic.in') }}
                        {{ casebreakout.distance}} {{ __('lang.units.meter') }}</td>
                    </tr>
                  </tbody>
                </table>
                <h5 class="mb-3" v-show="acoustics.length > 0">{{ __('lang.global.product.tabs.techdata.accoustics')}}
                </h5>

                <b-table v-show="acousticpoints.length > 1 && acousticslwa.length > 0" :items="acousticslwa"
                  :fields="table_fields_acousticslwa" caption-top striped>
                  <template #table-caption>{{__('lang.global.product.tabs.techdata.acoustic.powerlevel_head1')}}
                    {{lwapoint_pressure}}
                    {{__('lang.global.product.tabs.techdata.acoustic.powerlevel_head2')}}</template>
                  <template v-slot:cell(acoustictyp)="{item}">

                    <span>{{__('lang.global.product.tabs.techdata.acoustic.typ.'+item.acoustictyp)}}
                      {{ __('lang.global.product.tabs.techdata.acoustic.airtyp.'+item.airtyp)}}</span>
                  </template>
                </b-table>
                <b-table v-show="acousticpoints.length > 1 && acousticslpa.length > 0" :items="acousticslpa"
                  :fields="table_fields_acousticslwa" caption-top striped>
                  <template
                    #table-caption>{{__('lang.global.product.tabs.techdata.acoustic.pressurelevel_head')}}</template>
                  <template v-slot:cell(acoustictyp)="{item}">

                    <span>{{__('lang.global.product.tabs.techdata.casebreakout')}}
                      {{__('lang.global.product.tabs.techdata.acoustic.in')}} {{item.meter}}
                      {{__('lang.units.meter')}}
                    </span>
                  </template>
                </b-table>


                <!-- POINTS: <span v-for="point in acousticpoints">
                  {{point}}
                  && row.pointnr===point -->




                <b-table
                  v-show="acousticpoints.length==1 && acoustics.filter(row=>row.acoustictyp === 'lwa').length > 0"
                  striped :items="acoustics.filter(row=>row.acoustictyp === 'lwa')" :fields="table_fields_acoustics"
                  sort-icon-left caption-top>
                  <template #table-caption>{{
                  __('lang.global.product.tabs.techdata.acoustic.powerlevel_head_spectrum')}}</template>
                  <template v-slot:cell(acoustictyp)="{item}">

                    <span>{{__('lang.global.product.tabs.techdata.acoustic.typ.'+item.acoustictyp)}}
                      {{ __('lang.global.product.tabs.techdata.acoustic.airtyp.'+item.airtyp)}}</span>
                  </template>
                  <template v-slot:cell(dba)="{item}">
                    <span>{{ __('lang.global.product.tabs.techdata.acoustic.dba')}}</span>
                  </template>

                </b-table>
                <!--  </span> -->

                <b-table
                  v-show="acousticpoints.length==1 && acoustics.filter(row => row.acoustictyp === 'lpa').length > 0"
                  striped :items="acoustics.filter(row=>row.acoustictyp === 'lpa')" :fields="table_fields_acoustics"
                  sort-icon-left caption-top>
                  <template
                    #table-caption>{{__('lang.global.product.tabs.techdata.acoustic.pressurelevel_head_spectrum')}}</template>
                  <template v-slot:cell(acoustictyp)="{item}">

                    <span>{{__('lang.global.product.tabs.techdata.acoustic.typ.'+item.acoustictyp)}}
                      {{ __('lang.global.product.tabs.techdata.acoustic.airtyp.'+item.airtyp)}}
                      {{__('lang.global.product.tabs.techdata.acoustic.in')}} {{ item.distance}}
                      {{__('lang.units.meter')}}
                    </span>


                  </template>
                  <template v-slot:cell(dba)="{item}">
                    <span>{{ __('lang.global.product.tabs.techdata.acoustic.dba')}}</span>
                  </template>

                </b-table>



              </div>
              <!-- <div class="col-12 col-md-4">ToDo Maßbild als Image statt pdf:<img class="img-fluid" src="https://heliosselect.de/cms/upload/bilder/masse/png/html/mb5584001.png"></div> -->
              <div class="col-12 col-md-4" v-if="media_dimension_svg">
                <b-img class="img-fluid" :src="mediaserver_url+ media_dimension_svg"></b-img>
              </div>

              <!-- <div class="col-12 col-md-4"><object class="embed-responsive-item"  :data="media_dir + media_dimension" type="application/pdf"></object></div> -->
            </div>
          </div>
          <!-- <div :class="product_data.flag_fan!=1 ? 'tab-pane active': 'tab-pane'" id="downloads-tab-pane"> -->
          <div class="tab-pane" id="downloads-tab-pane">
            <h5 class="mb-3">{{ __('lang.global.product.downloads')}}</h5>
            <!-- <b-table class="table table-striped table-borderless table-responsive-md" striped borderless responsive="md" details-td-class="p-0" :items="product_data.product_media.filter(item => item.f_download==1 && item.media_type!= 'image')" :fields="table_fields_download" sort-icon-left> -->
            <b-table class="table table-striped table-borderless table-responsive-md" striped borderless responsive="md"
              details-td-class="p-0" :items="product_media.filter(item => item.media_type!== 'image' && item.filename!=='')"
              :fields="table_fields_download" sort-icon-left >
              <template #cell(media_type)="{item}">
                {{ __('lang.global.product.downloads.'+ item.media_type)}}
              </template>
              <template #cell(cloud)="{item}">
                <a class="text-primary" role="button" target="_blank"
                  :href="item.media_type==='vdi' || item.media_type=== 'revit' ? item.filename : mediaserver_url + item.path + item.filename">
                  <!--  <a class="text-primary" role="button" :href="mediaserver_url + item.path + item.filename"> -->
                  <svg class="icon icon-sm m-0">
                    <use xlink:href="/assets/img/icon-sprite.svg#global.download"
                      xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                  </svg>
                </a>
              </template>
              <template #cell(filetype)="{item}">
                <span v-if="item.filetype!='undefined' && item.filetype!=''">{{ __('lang.'+
                item.filetype.replace(/[^a-zA-Z]/, "_"))}}</span>
              </template>

                <template #custom-foot>

                    <b-tr :class="product_media.filter(item => item.media_type!== 'image' && item.filename!=='').length % 2 == 0?'footgrey':'footwhite'">
                        <b-th><span>{{__('lang.output.pdf.techdatasheet.header')}}</span></b-th>
                        <b-th></b-th>
                        <b-th><span><a class="text-primary font-weight-bold"  role="button" @click.prevent="createPdf">
                      <svg class="icon icon-sm m-0">
                          <use xlink:href="/assets/img/icon-sprite.svg#global.file.pdf"
                               xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                      </svg>

                  </a></span></b-th>

                    </b-tr>
                </template>


<!--

                <template #foot(media_type)="data">
                    <span>{{__('lang.output.pdf.techdatasheet.header')}}</span>
                </template>

                <template #foot(filename)="data"><span>{{''}}</span></template>
                <template #foot(cloud)="data">
                    <span><a class="text-primary font-weight-bold"  role="button" @click.prevent="createPdf">
                      <svg class="icon icon-sm m-0">
                          <use xlink:href="/assets/img/icon-sprite.svg#global.file.pdf"
                               xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                      </svg>

                  </a></span>
                </template>-->




            </b-table>
              <div class="mt-2">
                   <span class="d-block small font-weight-bold text-secondary ml-1">{{__('lang.global.product.tabs.downloads.zip.label')}}:</span>
                  <a class="text-primary small" role="button"  @click.prevent="createZip">
                      <svg class="icon">
                          <use xlink:href="/assets/img/icon-sprite.svg#global.arrow"
                               xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                      </svg>
                      {{__('lang.global.product.tabs.downloads.zip.link')}}
                  </a>
              </div>
          </div>
          <div v-if="product_data.flag_fan==1 && product_data.curvenexists" class="tab-pane" id="characteristics-tab-pane">
            <productdetailhighcharts ref="highcharttab" ismobile="desktop"></productdetailhighcharts>
          </div>
          <div v-show="media_ssplan!=''" class="tab-pane" id="diagram-tab-pane">
            <div class="embed-responsive embed-responsive-4by3">
              <object class="embed-responsive-item" :data="media_ssplan" type="application/pdf"></object>
            </div>
          </div>
          <div v-show="accessories.length > 0" class="tab-pane" id="equipment-tab-pane">
            <b-table class="table table-striped table-borderless table-responsive-md" striped borderless responsive="md"
              details-td-class="p-0" :items="accessories" :fields="table_fields" sort-icon-left primary-key="idx"> <!-- :items="keyedAccessoriesItems"   accessories   primary-key="idx" -->



              <template #cell(image)="row">
                  <span v-show="row.item.image && row.item.image!='undefined' && row.item.image!=''" >
                    <router-link
                      :to="{ name: 'productdetail', query: query_params(row.item.ref_no, row.item.product_child_version, 0) }"
                      role="button" target="_blank">
                      <span @click.prevent="opendetail(row.item.ref_no, row.item.product_child_version, 0)" role="link">
                        <b-img  class="img-fluid img-td-small" :src="row.item.image ? mediaserver_url + row.item.image : ''" fluid></b-img>
                      </span>
                    </router-link>
                    <p v-show="row.item.items && row.item.items.length > 0">
                      <button role="button" @click="row.toggleDetails" :class="row.item.items && row.item.items.length > 0 ? (row.detailsShowing ? 'btn btn-link btn-sm p-0' : 'btn btn-link btn-sm p-0 collapsed') : 'd-none'" data-toggle="collapse">
                        <svg class="icon icon-xxs">
                          <use xlink:href="/assets/img/icon-sprite.svg#global.collapse" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                        </svg>
                        {{ __('lang.global.product.tabs.accessories') }} {{ __('lang.global.to') }} {{ row.item.ref_no }}
                      </button>
                    </p>
                  </span>
              </template>
              <template #cell(ref_no)="row">
                <span v-if="row.item.state === 'A'">{{ row.item.ref_no }}</span>
                <span v-else>{{ row.item.ref_no }}-{{ row.item.version }}</span>
              </template>


              <template #cell(type)="typerow">
                  <div :id="'hoverBtnId_' + typerow.item.ref_no +'_'+ typerow.item.idx ">
                   <!--  <div :id="'hoverBtnId_' + typerow.item.ref_no"> -->
                    <b-button  variant="link" v-b-tooltip.hover class="text-left p-0">
                      <span>
                        <router-link :to="{ name: 'productdetail', query: query_params(typerow.item.ref_no, typerow.item.version, 1, typerow.item.execution) }"
                          class="text-primary" role="button" target="_blank">
                          <span @click.prevent="opendetail(typerow.item.ref_no, typerow.item.version, 1, typerow.item.execution)" role="link">{{ typerow.item.type }}</span>
                        </router-link>
                      </span>
                    </b-button><br>
                      {{ typerow.item.description_short }}
                      <br/>
                     <span class="small text-primary" v-show="typerow.item.state && typerow.item.state.toLowerCase() == 'v'">{{ __('lang.product.text.old') }}</span>
                    <!-- <b-button  variant="link" v-b-tooltip.hover class="text-left">test </b-button> -->
                  </div>
                  <b-popover :target="'hoverBtnId_' + typerow.item.ref_no + '_' + typerow.item.idx" triggers="hover" placement="auto"  custom-class="quickview">
                   <!-- <b-popover :target="'hoverBtnId_' + typerow.item.ref_no" triggers="hover" placement="auto"  custom-class="quickview"> -->
                      <template v-slot:default>
                        <div class="media">
                            <div v-show="typerow.item.image && typerow.item.image!=='undefined' && typerow.item.image!==''"><img  class="img-fluid" :src="mediaserver_url + typerow.item.image" alt="" /></div>

                            <div><h6>{{ typerow.item.type }}</h6>
                            <p>{{ getLongDesc(typerow.item.description_long) }}</p>

                            </div>
                        </div>
                      </template>

                  </b-popover>
              </template>

              <template #cell(info)="row">
                <div class="text-center">
                  <button role="button" @click="row.toggleDetails"
                    :class="row.detailsShowing ?  'btn m-0 p-0 text-primary' : 'btn m-0 p-0 text-primary collapsed'"
                    data-toggle="collapse">
                    <svg class="icon">
                      <use xlink:href="/assets/img/icon-sprite.svg#global.collapse"
                        xmlns:xlink="http://www.w3.org/1999/xlink">
                      </use>
                    </svg>
                  </button>
                </div>
              </template>

              <template #row-details="row">
                <div class="bg-white">
                  <div class="border-bottom">
                    <div class="container-fluid py-3">
                      <!-- <b-button size="sm" @click="row.toggleDetails">Hide Details</b-button> -->
                      <div class="row justify-content-center">
                        <!-- <div class="col-2"><img class="img-fluid" :src="mediaserver_url + row.item.image" /></div> -->
                        <div class="col-6  mt-n3">
                          <!-- <p class="mb-0">{{row.item.type}}</p>
                          <h5 class="mb-3">{{row.item.description_short}}</h5> -->
                          <p>{{row.item.description_long}}</p>
                          <ul class="list-unstyled downloads">
                            <li class="mb-1">
                              <router-link
                                :to="{ name: 'productdetail', query: query_params(row.item.ref_no,row.item.product_child_version,0)}"
                                class="text-primary font-weight-bold" role="button" target="_blank">
                                <span @click.prevent="opendetail(row.item.ref_no,row.item.product_child_version,0)"
                                  role="link">
                                  <svg class="icon">
                                    <use xlink:href="/assets/img/icon-sprite.svg#global.external-link"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                  </svg>{{__('lang.global.product.downloads.toproductdetailpage')}}
                                </span>
                              </router-link>
                            </li>
                            <li :class="(row.item.datasheet=='undefined' || !row.item.datasheet) ? 'd-none':'mb-1' "><a
                                class="text-primary font-weight-bold" :href="mediaserver_url + row.item.datasheet"
                                target="_blank" role="button">
                                <svg class="icon">
                                  <use xlink:href="/assets/img/icon-sprite.svg#global.file.pdf"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                </svg>{{__('lang.global.product.downloads.datasheet')}}</a></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="bg-white pl-8 small">
                 <!--  <button v-b-toggle="'collapse-' + row.item.ref_no"
                    :class="!row.item.items ?'d-none' :'btn btn-link btn-sm p-0'"
                    @click="$event.target.classList.toggle('collapsed')" data-toggle="collapse">
                    <svg class="icon icon-xxs">
                      <use xlink:href="/assets/img/icon-sprite.svg#global.collapse"
                        xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                    </svg>
                    {{__('lang.global.product.tabs.accessories')}} {{__('lang.global.to')}} {{row.item.ref_no}}
                  </button>
                  <b-collapse :id="'collapse-'+ row.item.ref_no" class="mt-2 border-bottom"> -->
                    <p :class="!row.item.items ? 'd-none' : 'font-weight-bold pt-1'">{{ __('lang.global.product.tabs.accessories') }} {{ __('lang.global.to') }} {{ row.item.ref_no }}</p>

                    <b-table class="table table-striped table-borderless table-responsive-md nesteditemsrow"
                      thead-tr-class="d-none" details-td-class="p-0 py-0" striped borderless responsive="md"
                      :items="row.item.items" :fields="table_fields" sort-icon-left :id="'items_'+ row.item.ref_no">


                      <template #cell(image)="rownested">
                          <span v-show="rownested.item.image !='undefined'">
                            <router-link
                              :to="{ name: 'productdetail', query: query_params(rownested.item.ref_no, rownested.item.product_child_version, 0) }"
                              role="button" target="_blank">
                              <span @click.prevent="opendetail(rownested.item.ref_no, rownested.item.product_child_version, 0)" role="link">
                                <b-img class="img-td-small-3" :src="rownested.item.image ? mediaserver_url + rownested.item.image : ''" fluid></b-img>
                              </span>
                            </router-link>
                           <!--  <p>
                              <button role="button" @click="row.toggleDetails" :class="row.item.items && row.item.items.length > 0 ? (row.detailsShowing ? 'btn btn-link btn-sm p-0' : 'btn btn-link btn-sm p-0 collapsed') : 'd-none'" data-toggle="collapse">
                                <svg class="icon icon-xxs">
                                  <use xlink:href="/assets/img/icon-sprite.svg#global.collapse" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                </svg>
                                {{ __('lang.global.product.tabs.accessories') }} {{ __('lang.global.to') }} {{ row.item.ref_no }}
                              </button>
                            </p> -->
                          </span>
                          <!--  <span> {{ getAccessoriesCount(row.item) }}</span> -->
                      </template>

                     <!--  <template #cell(type)="typerow">
                          <div :id="'hoverBtnId_' + typerow.item.ref_no">
                            <b-button  variant="link" v-b-tooltip.hover class="text-left p-0">
                              <span>
                                <router-link :to="{ name: 'productdetail', query: query_params(typerow.item.ref_no, typerow.item.version, 1, typerow.item.execution) }"
                                  class="text-primary" role="button" target="_blank">
                                  <span @click.prevent="opendetail(typerow.item.ref_no, typerow.item.version, 1, typerow.item.execution)" role="link">{{ typerow.item.type }}</span>
                                </router-link>
                              </span>
                            </b-button><br>
                              {{ typerow.item.description_short }}

                          </div>
                          <b-popover :target="'hoverBtnId_' + typerow.item.ref_no" triggers="hover" placement="auto"  custom-class="quickview">

                              <template v-slot:default>
                                <div class="media"><div><img class="img-fluid" :src="mediaserver_url + typerow.item.image" /></div>
                                    <div><h6>{{ typerow.item.type }}</h6>
                                    <p>{{ getLongDesc(typerow.item.description_long) }}</p>

                                    </div>
                                </div>
                              </template>

                          </b-popover>

                      </template>
 -->
                      <template #cell(type)="typerow">


                              <span>
                                <router-link :to="{ name: 'productdetail', query: query_params(typerow.item.ref_no, typerow.item.version, 1, typerow.item.execution) }"
                                  class="text-primary" role="button" target="_blank">
                                  <span @click.prevent="opendetail(typerow.item.ref_no, typerow.item.version, 1, typerow.item.execution)" role="link">{{ typerow.item.type }}</span>
                                </router-link>
                              </span>
                            <br>
                              {{ typerow.item.description_short }}



                      </template>





                      <template #cell(info)="row2">
                        <button role="button" @click="row2.toggleDetails"
                          :class="row2.detailsShowing ?  'btn m-0 p-0 text-primary' : 'btn m-0 p-0 text-primary collapsed'"
                          data-toggle="collapse">
                          <svg class="icon">
                            <use xlink:href="/assets/img/icon-sprite.svg#global.collapse"
                              xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                          </svg>
                        </button>
                      </template>
                      <template #row-details="row2">

                        <div class="bg-white">

                          <div class="border-bottom">
                            <div class="container-fluid py-3">
                              <div class="row justify-content-center">
                               <!--  <div class="col-2"><img class="img-fluid" :src="mediaserver_url + row2.item.image" />
                                </div> -->
                                <div class="col-8 mt-n3">
                                  <!-- <p class="mb-0">{{row2.item.type}}</p>
                                  <h5 class="mb-3">{{row2.item.description_short}}</h5> -->
                                  <p>{{row2.item.description_long}}</p>
                                  <ul class="list-unstyled downloads">
                                    <li class="mb-1">
                                      <router-link
                                        :to="{ name: 'productdetail', query: query_params(row2.item.ref_no,row2.item.product_child_version,0)}"
                                        class="text-primary font-weight-bold" role="button" target="_blank">
                                        <span
                                          @click.prevent="opendetail(row2.item.ref_no,row2.item.product_child_version,0)"
                                          role="link">
                                          <svg class="icon">
                                            <use xlink:href="/assets/img/icon-sprite.svg#global.external-link"
                                              xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                          </svg>{{__('lang.global.product.downloads.toproductdetailpage')}}
                                        </span>
                                      </router-link>
                                    </li>
                                    <li :class="!row2.item.datasheet ? 'd-none' :'mb-2'"><a
                                        class="text-primary font-weight-bold"
                                        :href="mediaserver_url + row2.item.datasheet" target="_blank" role="button">
                                        <svg class="icon">
                                          <use xlink:href="/assets/img/icon-sprite.svg#global.file.pdf"
                                            xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                        </svg>{{__('lang.global.product.downloads.datasheet')}}</a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </template>
                    </b-table>
                 <!--  </b-collapse> -->
                </div>
              </template>
            </b-table>
          </div>
          <div v-show="product_data.flag_fan==2 && product_data.parentsexists"  class="tab-pane" id="parents-tab-pane">
            <div class="form-group col-12">
              <b-form-checkbox id="productstate" v-model="productstate" name="productstate" value="1">
              {{__('lang.global.product.tabs.suitable.productstate.cb')}}
              </b-form-checkbox>
            </div>
            <b-table class="table table-striped table-borderless table-responsive-md" striped borderless responsive="md"
              details-td-class="p-0" :items="productstate==='1' ? productparents : productparents.filter(row => row.state === 'A')" :fields="table_fields" sort-icon-left primary-key="idx">
              <template #cell(ref_no)="row">
               <span v-if="row.item.state === 'A'">{{row.item.ref_no}}</span>
               <span v-else>{{row.item.ref_no}}-{{row.item.version}}</span>

              </template>
              <!-- <template v-slot:cell(type)="row">
                {{row.item.type}}<br/>
                <span>
                  <router-link :to="{ name: 'productdetail', query: query_params(row.item.ref_no, row.item.version,0)}" class="text-primary"
                    role="button" target="_blank">
                    <span @click.prevent="opendetail(row.item.ref_no, row.item.version,0)" role="link">{{row.item.type}}</span>
                  </router-link>
                </span><br>
                <span class="small text-primary" v-if="row.item.state.toLowerCase()=='v'">{{__('lang.product.text.old')}}</span>
              </template> -->
               <template #cell(image)="row">
                        <span  v-show="row.item.image  !='undefined'">
                          <router-link
                            :to="{ name: 'productdetail', query: query_params(row.item.ref_no, row.item.version, 0) }"
                            role="button" target="_blank">
                            <span @click.prevent="opendetail(row.item.ref_no, row.item.product_child_version, 0)" role="link">
                              <b-img class="img-fluid img-td-small" :src="row.item.image ? mediaserver_url + row.item.image : ''" fluid></b-img>
                            </span>
                          </router-link>

                        </span>
                    </template>

                    <template #cell(type)="typerow">
                        <div :id="'hoverBtnId_' + typerow.item.ref_no + '_' + typerow.item.idx">
                         <!--  <div :id="'hoverBtnId_' + typerow.item.ref_no"> -->
                          <b-button  variant="link" v-b-tooltip.hover class="text-left p-0">
                            <span>
                              <router-link :to="{ name: 'productdetail', query: query_params(typerow.item.ref_no, typerow.item.version, 1, typerow.item.execution) }"
                                class="text-primary" role="button" target="_blank">
                                <span @click.prevent="opendetail(typerow.item.ref_no, typerow.item.version, 1, typerow.item.execution)" role="link">{{ typerow.item.type }}</span>
                              </router-link>
                            </span>
                          </b-button><br>
                            {{ typerow.item.description_short }}<br/>
                          <span class="small text-primary" v-if="typerow.item.state.toLowerCase() == 'v'">{{ __('lang.product.text.old') }}</span>
                        </div>
                        <b-popover :target="'hoverBtnId_' + typerow.item.ref_no + '_' + typerow.item.idx" triggers="hover" placement="auto"  custom-class="quickview">
                         <!-- <b-popover :target="'hoverBtnId_' + typerow.item.ref_no" triggers="hover" placement="auto"  custom-class="quickview"> -->
                            <template v-slot:default>
                              <div class="media">
                                  <div v-show="typerow.item.image && typerow.item.image!=='undefined' && typerow.item.image!==''"><img  class="img-fluid" :src="mediaserver_url + typerow.item.image" alt=""/></div>
                                  <div><h6>{{ typerow.item.type }}</h6>
                                  <p>{{ getLongDesc(typerow.item.description_long) }}</p>

                                  </div>
                              </div>
                            </template>

                        </b-popover>
                    </template>
              <template #cell(info)="row">
                <div class="text-center">
                  <button role="button" @click="row.toggleDetails"
                    :class="row.detailsShowing ?  'btn m-0 p-0 text-primary' : 'btn m-0 p-0 text-primary collapsed'"
                    data-toggle="collapse">
                    <svg class="icon">
                      <use xlink:href="/assets/img/icon-sprite.svg#global.collapse" xmlns:xlink="http://www.w3.org/1999/xlink">
                      </use>
                    </svg>
                  </button>
                </div>
              </template>
              <template #row-details="row">
                <div class="bg-white">
                  <div class="border-bottom">
                    <div class="container-fluid py-3">
                      <!-- <b-button size="sm" @click="row.toggleDetails">Hide Details</b-button> -->
                      <div class="row justify-content-center">
                        <!-- <div class="col-2"><img class="img-fluid" :src="mediaserver_url + row.item.image" /></div> -->
                        <div class="col-8 mt-n3">
                         <!--  <p class="mb-0">{{row.item.type}}</p>
                          <h5 class="mb-3">{{row.item.description_short}}</h5> -->
                          <p>{{row.item.description_long}}</p>
                          <ul class="list-unstyled downloads">
                            <li class="mb-1">
                              <router-link
                                :to="{ name: 'productdetail', query: query_params(row.item.ref_no,row.item.version,0)}"
                                class="text-primary font-weight-bold" role="button" target="_blank">
                                <span @click.prevent="opendetail(row.item.ref_no,row.item.version,0)" role="link">
                                  <svg class="icon">
                                    <use xlink:href="/assets/img/icon-sprite.svg#global.external-link"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                  </svg>{{__('lang.global.product.downloads.toproductdetailpage')}}
                                </span>
                              </router-link>
                            </li>
                            <li :class="(row.item.datasheet=='undefined' || !row.item.datasheet) ? 'd-none':'mb-1' "><a
                                class="text-primary font-weight-bold" :href="mediaserver_url + row.item.datasheet" target="_blank"
                                role="button">
                                <svg class="icon">
                                  <use xlink:href="/assets/img/icon-sprite.svg#global.file.pdf"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                </svg>{{__('lang.global.product.downloads.datasheet')}}</a></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </template>
            </b-table>
          </div>
          <div v-show="media_lvtext!=''"  class="tab-pane" id="lv-tab-pane">
              <!--<button @click="copyLVText">Copy</button> -->
              <div class="embed-responsive embed-responsive-4by3">
                  <object class="embed-responsive-item" :data="media_lvtext" type="text/plain" id="lvtextObject" ref="lvtextObject"></object>
              </div>
        </div>
        <!-- cadenas: -->
          <div   class="tab-pane" id="cadenas-tab-pane">

              <!-- <div v-show="user.auth" class="embed-responsive embed-responsive-16by9 iframe-container"> -->
              <div v-show="user.auth">
                <iframe  v-resize="iframeResizerOptions"  class="embed-responsive-item" id="iframeCadenas" :src="iframeCadenas.src"  allowfullscreen   ref="iframeCadenasRef"
                  frameborder="0" width="100%" height="100%"></iframe> <!--  onload="if ('parentIFrame' in window) { alert('bin ich da?'); parentIFrame.size(1000)  "  onload="if ('parentIFrame' in window) { alert('bin ich da?'); parentIFrame.size(1000)}"-->

              </div>


              <div v-show="!user.auth"  class="row text-center"><div class="col-8 m-8">{{__('lang.message.loginrequired') }}</div></div>


                <!-- <iframe  id="iframeCadenas"  :src="iframeCadenas.src"  @load="loadIframeCadenas()"  loading="lazy"></iframe>   -->
                <!-- <iframe width="510" height="610" src="https://b2b.partcommunity.com/community/partcloud/embedded.html#!embedded?name=Nussknacker&model_id=24755&portal=b2b&showDescription=true&showLicense=true&showDownloadButton=false&noAutoload=false&autoRotate=false&hideMenu=false&topColor=%23dde7ed&bottomColor=%23ffffff&cameraParams=false&varsettransfer=" frameborder="0" id="EmbeddedView-Iframe-24755" allowfullscreen></iframe> -->
                <!-- <iframe id="iframeCadenas" src="https://heliosventilatoren.qa.partcommunity.com/3d-cad-models/sso/amd-entrauchungs-axial-ventilator-helios?info=helios%2Fhelios20ventilatoren%2Faxialventilatoren%2Famd.prj&cwid=3912&showDescription=true&showLicense=true&showDownloadButton=true&noAutoload=false&autoRotate=false&hideMenu=false&topColor=%23dde7ed&bottomColor=%23ffffff&cameraParams=false&varsettransfer=" frameborder="0" allowfullscreen></iframe> -->


                <!-- https://heliosventilatoren.qa.partcommunity.com/3d-cad-models/sso/amd-entrauchungs-axial-ventilator-helios?info=helios%2Fhelios20ventilatoren%2Faxialventilatoren%2Famd.prj&cwid=3912 -->
          </div>
          <!-- :cadenas -->

        </div>
      </div>
    </div>

    <!-- Mobile: -->
    <div v-if="isMobile()" class="row mb-4 d-md-none">
      <div class="col-12">
        <ul class="nav flex-column level-1" id="accordion">
          <li class="nav-item w-100"><a
              class="nav-link px-0 d-flex align-items-center justify-content-between border-bottom collapsed h4 text-gray-50 font-weight-light"
              data-toggle="collapse" href="#collapseData" aria-expanded="true" aria-controls="collapseData"
              role="button"><span class="col-auto">{{__('lang.global.product.tabs.data')}}</span><span
                class="col-auto pl-3">
                <svg class="icon icon-sm m-0">
                  <use xlink:href="/assets/img/icon-sprite.svg#global.collapse"
                    xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg></span></a>
            <div class="collapse show" id="collapseData" data-parent="#accordion">
              <div class="container">
                <div class="row py-3">
                  <div class="col-12">
                    <h5 class="mb-3">{{ __('lang.global.product.tabs.techdata.info')}}</h5>
                    <b-table :items="productitems" :fields="table_fields_techproperties" stacked striped class="techdata table-sm">
                      <template v-slot:cell(explosionproof)="{item}">
                        <svg class="icon" v-if="item.explosionproof == 1">
                          <use xlink:href="/assets/img/icon-sprite.svg#global.check" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                        </svg>
                        <!--  <b-img v-bind="checkprops" rounded="circle" alt="yes"></b-img> -->
                      </template>
                      <template v-slot:cell(ec_technology)="{item}">
                        <svg class="icon" v-if="item.ec_technology == 1">
                          <use xlink:href="/assets/img/icon-sprite.svg#global.check" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                        </svg>
                      </template>
                      <template v-slot:cell(lining)="{item}">
                        <svg class="icon" v-if="item.lining == 1">
                          <use xlink:href="/assets/img/icon-sprite.svg#global.check" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                        </svg>
                      </template>
                    </b-table>

                  <!--   <table class="table table-sm table-striped table-borderless mb-3">
                      <tbody>
                        <tr>
                          <th class="small border-right align-middle" scope="row">{{
                          __('lang.global.product.tabs.techdata.refno')}}</th>
                          <td>{{product_data.ref_no}} - {{product_data.version}}</td>
                        </tr>
                        <tr>
                          <th class="small border-right align-middle" scope="row">{{
                          __('lang.global.product.tabs.techdata.type')}}</th>
                          <td>{{product_data.type}}</td>
                        </tr>
                        <tr>
                          <th class="small border-right align-middle" scope="row">{{
                          __('lang.global.product.tabs.techdata.desc_short')}}</th>
                          <td>{{product_data.description_short}}</td>
                        </tr>
                        <tr v-if="parseFloat(op.pressure)>0">
                          <th class="small border-right align-middle" scope="row">{{
                          __('lang.global.product.tabs.techdata.pressure_actual')}}</th>
                          <td>{{op.pressure}} {{units_selected.pressureunits}} {{
                          __('lang.externalpressuretyp.'+
                          op.pressuretype)}} </td>
                        </tr>
                        <tr v-if="parseFloat(op.airflow)>0">
                          <th class="small border-right align-middle" scope="row">{{
                          __('lang.global.product.tabs.techdata.airflow_actual')}}</th>
                          <td>{{op.airflow}} {{units_selected.airflowunits}}</td>
                        </tr>
                        <tr>
                          <th class="small border-right align-middle" scope="row">{{
                          __('lang.global.product.tabs.techdata.airflow_max')}}</th>
                          <td>{{product_data.max_volumeflow}} {{ __('lang.units.airflow_volume') }}</td>
                        </tr>
                        <tr>
                          <th class="small border-right align-middle" scope="row">{{
                          __('lang.global.product.tabs.techdata.rpm')}}</th>
                          <td>{{product_data.rpm1}}<span v-if="parseFloat(product_data.rpm2)>0"> /
                              {{product_data.rpm2}}</span> {{ __('lang.units.rpm') }}</td>
                        </tr>
                        <tr>
                          <th class="small border-right align-middle" scope="row">{{
                          __('lang.global.product.tabs.techdata.flc_uncontrolled')}}</th>
                          <td>{{product_data.flc_uncontrolled1}}<span
                              v-if="parseFloat(product_data.flc_uncontrolled2)>0">
                              /
                              {{product_data.flc_uncontrolled2}}</span> {{ __('lang.units.amper') }}</td>
                        </tr>
                        <tr>
                          <th class="small border-right align-middle" scope="row">{{
                          __('lang.global.product.tabs.techdata.stc_uncontrolled')}}</th>
                          <td><span v-if="stc_uncontrolled!=0">{{stc_uncontrolled}} {{ __('lang.units.amper')
                          }}</span></td>
                        </tr>
                        <tr>
                          <th class="small border-right align-middle" scope="row">{{
                          __('lang.global.product.tabs.techdata.stc_uncontrolled')}}</th>
                          <td><span v-if="parseFloat(product_data.stc_uncontrolled)>0">{{product_data.stc_uncontrolled}} {{ __('lang.units.amper')
                          }}</span></td>
                        </tr>
                        <tr>
                          <th class="small border-right align-middle" scope="row">{{
                          __('lang.global.product.tabs.techdata.power')}}</th>
                          <td>{{product_data.power1}}<span v-if="parseFloat(product_data.power2)>0"> /
                              {{product_data.power2}}</span> {{ __('lang.units.kilowatt') }}</td>
                        </tr>
                        <tr>
                          <th class="small border-right align-middle" scope="row">{{
                          __('lang.global.product.tabs.techdata.voltage')}}</th>
                          <td>{{voltage}}</td>
                        </tr>
                        <tr>
                          <th class="small border-right align-middle" scope="row">{{
                          __('lang.global.product.tabs.techdata.protectionclass')}}</th>
                          <td>{{product_data.protectionclass}}</td>
                        </tr>
                        <tr>
                          <th class="small border-right align-middle" scope="row">{{
                          __('lang.global.product.tabs.techdata.temp_max')}}</th>
                          <td>{{max_temp}} {{ __('lang.units.degree') }}<br>
                          </td>
                        </tr>
                        <tr>
                          <th class="small border-right align-middle" scope="row">{{
                          __('lang.global.product.tabs.techdata.ssplan_no')}}</th>
                          <td>{{product_data.ss_nr}}</td>
                        </tr>
                        <tr>
                          <th class="small border-right align-middle" scope="row">{{
                          __('lang.global.product.tabs.techdata.weight')}}</th>
                          <td>{{product_data.weight}} {{ __('lang.units.kilo') }}</td>
                        </tr>
                        <tr>
                          <th class="small border-right" scope="row">{{
                          __('lang.global.product.tabs.techdata.delivery')}}
                          </th>
                          <td><span v-if="parseFloat(product_data.delivery)>0">{{product_data.delivery}}
                              {{__('lang.units.week')}}</span>
                            <span v-else>{{__('lang.global.onrequest')}}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table> -->
                    <h5 class="mb-3" v-show="soundinduct.lwa > 0 || casebreakout.lwa > 0">{{
                    __('lang.global.product.tabs.techdata.acousticdata')}}</h5>

                    <table v-show="soundinduct.lwa > 0 || casebreakout.lwa > 0"
                      class="table table-sm table-striped table-borderless mb-3">
                      <tbody>
                        <tr v-show="soundinduct.lwa > 0">
                          <th class="small border-right align-middle" scope="row">{{
                          __('lang.global.product.tabs.techdata.soundinduct')}}</th>
                          <td>{{soundinduct.lwa}} {{ __('lang.global.product.tabs.techdata.acoustic.dba') }}
                            {{__('lang.global.product.tabs.techdata.acoustic.in') }}
                            {{soundinduct.distance }} {{__('lang.units.meter') }}</td>
                        </tr>
                        <tr v-show="casebreakout.lwa > 0">
                          <th class="small border-right align-middle" scope="row">{{
                          __('lang.global.product.tabs.techdata.casebreakout')}}</th>
                          <td>{{casebreakout.lwa}} {{ __('lang.global.product.tabs.techdata.acoustic.dba') }}
                            {{__('lang.global.product.tabs.techdata.acoustic.in') }}
                            {{casebreakout.distance }} {{ __('lang.units.meter') }}</td>
                        </tr>
                      </tbody>
                    </table>

                    <h5 class="mb-3" v-show="acoustics.length > 0">{{
                    __('lang.global.product.tabs.techdata.accoustics')}}
                    </h5>

                    <b-table v-show="acousticpoints.length > 1 && acousticslwa.length > 0" :items="acousticslwa"
                      :fields="table_fields_acousticslwa" caption-top class="table-responsive" striped>
                      <template #table-caption>{{__('lang.global.product.tabs.techdata.acoustic.powerlevel_head1')}}
                        {{lwapoint_pressure}}
                        {{__('lang.global.product.tabs.techdata.acoustic.powerlevel_head2')}}</template>
                      <template v-slot:cell(acoustictyp)="{item}">

                        <span>{{__('lang.global.product.tabs.techdata.acoustic.typ.'+item.acoustictyp)}}
                          {{ __('lang.global.product.tabs.techdata.acoustic.airtyp.'+item.airtyp)}}</span>
                      </template>
                    </b-table>
                    <b-table v-show="acousticpoints.length > 1 && acousticslpa.length > 0" :items="acousticslpa"
                      :fields="table_fields_acousticslwa" caption-top class="table-responsive" striped>
                      <template
                        #table-caption>{{__('lang.global.product.tabs.techdata.acoustic.pressurelevel_head')}}</template>
                      <template v-slot:cell(acoustictyp)="{item}">

                        <span>{{__('lang.global.product.tabs.techdata.acoustic.typ.'+item.acoustictyp)}}
                          {{ __('lang.global.product.tabs.techdata.acoustic.airtyp.'+item.airtyp)}}
                          {{__('lang.global.product.tabs.techdata.acoustic.in')}} {{ item.distance}}
                          {{__('lang.units.meter')}}
                        </span>
                      </template>
                    </b-table>

                    <b-table
                      v-show="acousticpoints.length==1 && acoustics.filter(row=>row.acoustictyp === 'lwa').length > 0"
                      class="table-responsive" striped :items="acoustics.filter(row=>row.acoustictyp === 'lwa')"
                      :fields="table_fields_acoustics" sort-icon-left caption-top>
                      <template #table-caption>{{
                      __('lang.global.product.tabs.techdata.acoustic.powerlevel_head_spectrum')}}</template>
                      <template v-slot:cell(acoustictyp)="{item}">

                        <span>{{__('lang.global.product.tabs.techdata.acoustic.typ.'+item.acoustictyp)}}
                          {{ __('lang.global.product.tabs.techdata.acoustic.airtyp.'+item.airtyp)}}</span>
                      </template>
                      <template v-slot:cell(dba)="{item}">
                        <span>{{ __('lang.global.product.tabs.techdata.acoustic.dba')}}</span>
                      </template>

                    </b-table>


                    <b-table
                      v-show="acousticpoints.length==1 && acoustics.filter(row => row.acoustictyp === 'lpa').length > 0"
                      class="table-responsive" striped :items="acoustics.filter(row=>row.acoustictyp === 'lpa')"
                      :fields="table_fields_acoustics" sort-icon-left caption-top>
                      <template #table-caption>{{
                      __('lang.global.product.tabs.techdata.acoustic.pressurelevel_head_spectrum')}}</template>>
                      <template v-slot:cell(acoustictyp)="{item}">
                        <span>{{__('lang.global.product.tabs.techdata.acoustic.typ.'+item.acoustictyp)}}
                          {{ __('lang.global.product.tabs.techdata.acoustic.airtyp.'+item.airtyp)}}</span>
                      </template>
                      <template v-slot:cell(dba)="{item}">
                        <span>{{ __('lang.global.product.tabs.techdata.acoustic.dba')}}</span>
                      </template>

                    </b-table>
                  </div>
                  <div class="col-12 col-md-4" v-if="media_dimension_svg">
                    <b-img class="img-fluid" :src="mediaserver_url+ media_dimension_svg"></b-img>
                  </div>

                  <!-- <div class="col-12 col-md-4"><object class="embed-responsive-item"  :data="media_dir + media_dimension" type="application/pdf"></object></div> -->



                  <!-- </div>
                      </div>
 -->
                </div>
              </div>
            </div>
          </li>
          <li class="nav-item w-100"><a
              class="nav-link px-0 d-flex align-items-center justify-content-between border-bottom collapsed h4 text-gray-50 font-weight-light"
              data-toggle="collapse" href="#collapseDownloads" aria-expanded="true" aria-controls="collapseDownloads"
              role="button" @click="getProductDownloads"><span class="col-auto">{{
              __('lang.global.product.downloads')}}</span><span class="col-auto pl-3">
                <svg class="icon icon-sm m-0">
                  <use xlink:href="/assets/img/icon-sprite.svg#global.collapse"
                    xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg></span></a>
            <div class="collapse" id="collapseDownloads" data-parent="#accordion">
              <div class="container">
                <div class="row py-3">
                  <div class="col-12">
                    <h5 class="mb-3">{{ __('lang.global.product.downloads')}}</h5>
                    <!-- <b-table class="table table-striped table-borderless table-responsive-md" striped borderless responsive="md" details-td-class="p-0" :items="product_data.product_media.filter(item => item.f_download==1 && item.media_type!= 'image')" :fields="table_fields_download" sort-icon-left> -->
                    <b-table class="table table-striped table-borderless table-responsive-md" striped borderless
                      responsive="md" details-td-class="p-0"
                      :items="product_media.filter(item => item.media_type!= 'image' && item.filename!='')" :fields="table_fields_download"
                      sort-icon-left>
                      <template #cell(media_type)="{item}">
                        {{ __('lang.global.product.downloads.'+ item.media_type)}}
                      </template>
                      <template #cell(cloud)="{item}">
                        <a class="text-primary" role="button" target="_blank"
                          :href="item.media_type==='vdi' || item.media_type=== 'revit' ? item.filename : mediaserver_url + item.path + item.filename">
                          <!--  <a class="text-primary" role="button" :href="mediaserver_url + item.path + item.filename"> -->
                          <svg class="icon icon-sm m-0">
                            <use xlink:href="/assets/img/icon-sprite.svg#global.download"
                              xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                          </svg>
                        </a>
                      </template>
                      <template #cell(filetype)="{item}">
                        <span v-if="item.filetype!='undefined' && item.filetype!=''">{{ __('lang.'+
                        item.filetype.replace(/[^a-zA-Z]/, "_"))}}</span>
                      </template>
                    </b-table>
                  </div>
                </div>
              </div>
            </div>
          </li>


          <li class="nav-item w-100" v-show="product_data.flag_fan==1"><a
              class="nav-link px-0 d-flex align-items-center justify-content-between border-bottom collapsed h4 text-gray-50 font-weight-light"
              data-toggle="collapse" href="#collapseCharacteristics" aria-expanded="false"
              aria-controls="collapseCharacteristics" role="button" @click="getProductCurves"><span class="col-auto" id="collapseCharacteristicsTitle">{{
              __('lang.global.product.tabs.curves')}}</span><span class="col-auto pl-3">
                <svg class="icon icon-sm m-0">
                  <use xlink:href="/assets/img/icon-sprite.svg#global.collapse"
                    xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg></span></a>
            <div class="collapse" id="collapseCharacteristics" data-parent="#accordion">
              <div class="container">
                <div class="row py-3">
                  <div class="col-12">
                    <productdetailhighcharts ref="highcharttab" ismobile="mobile"></productdetailhighcharts>
                  </div>
                </div>
              </div>
            </div>
          </li>

          <li class="nav-item w-100" v-show="media_ssplan!=''"><a
              class="nav-link px-0 d-flex align-items-center justify-content-between border-bottom collapsed h4 text-gray-50 font-weight-light"
              data-toggle="collapse" href="#collapseSSPlan" aria-expanded="false" aria-controls="collapseSSPlan"
              role="button"><span class="col-auto">{{ __('lang.global.product.tabs.ssplan')}}</span><span
                class="col-auto pl-3">
                <svg class="icon icon-sm m-0">
                  <use xlink:href="/assets/img/icon-sprite.svg#global.collapse"
                    xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg></span></a>
            <div class="collapse" id="collapseSSPlan" data-parent="#accordion">
              <div class="container">
                <div class="row py-3">
                  <div class="col-12">

                    <object class="embed-responsive-item" :data="media_ssplan" type="application/pdf"></object>
                  </div>
                </div>
              </div>
            </div>
          </li>

            <li class="nav-item w-100" v-show="media_lvtext!=''"><a
                class="nav-link px-0 d-flex align-items-center justify-content-between border-bottom collapsed h4 text-gray-50 font-weight-light"
                data-toggle="collapse" href="#collapseLVText" aria-expanded="false"
                aria-controls="collapseLvText" role="button" ><span class="col-auto">{{
                    __('lang.global.product.tabs.lvtext')}}</span><span class="col-auto pl-3">
                <svg class="icon icon-sm m-0">
                  <use xlink:href="/assets/img/icon-sprite.svg#global.collapse"
                       xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg></span></a>
                <div class="collapse" id="collapseLVText" data-parent="#accordion">
                    <div class="container">
                        <div class="row py-3">
                            <div class="col-12">
                                <div class="embed-responsive embed-responsive-4by3">
                                    <object class="embed-responsive-item" :data="media_lvtext" type="text/plain"></object>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </li>




          <li class="nav-item w-100" v-show="accessories.length > 0"><a
              class="nav-link px-0 d-flex align-items-center justify-content-between border-bottom collapsed h4 text-gray-50 font-weight-light"
              data-toggle="collapse" href="#collapseEquipment" aria-expanded="true" aria-controls="collapseEquipment"
              role="button" @click="getProductAccessories"><span
                class="col-auto">{{__('lang.global.product.tabs.accessories')}}</span><span class="col-auto pl-3">
                <svg class="icon icon-sm m-0">
                  <use xlink:href="/assets/img/icon-sprite.svg#global.collapse"
                    xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg></span></a>
            <div class="collapse" id="collapseEquipment" data-parent="#accordion">
               <b-table class="table table-striped table-borderless table-responsive" striped borderless responsive="md" details-td-class="p-0" :items="accessories" :fields="table_fields" sort-icon-left>
                    <template #cell(ref_no)="row">
                        <span v-if="row.item.state === 'A'">{{ row.item.ref_no }}</span>
                        <span v-else>{{ row.item.ref_no }}-{{ row.item.version }}</span>
                    </template>
                    <template v-slot:cell(type)="row">
                        {{ row.item.type }}<br/>
                        <span class="small text-primary" v-if="row.item.state.toLowerCase() == 'v'">{{ __('lang.product.text.old') }}</span>
                    </template>



                    <template #cell(image)="row">
                    <span v-show="row.item.image  && row.item.image !=='undefined' && row.item.image !==''">
                      <router-link
                          :to="{ name: 'productdetail', query: query_params(row.item.ref_no, row.item.product_child_version, 0) }"
                          role="button" target="_blank">
                        <span @click.prevent="opendetail(row.item.ref_no, row.item.product_child_version, 0)" role="link">
                          <b-img class="img-fluid img-td-small" :src="row.item.image ? mediaserver_url + row.item.image : ''" fluid alt=""></b-img>
                        </span>
                      </router-link>
                      <p v-show="row.item.items && row.item.items.length > 0">
                        <button role="button" @click="row.toggleDetails" :class="row.item.items && row.item.items.length > 0 ? (row.detailsShowing ? 'btn btn-link btn-sm p-0' : 'btn btn-link btn-sm p-0 collapsed') : 'd-none'" data-toggle="collapse">
                          <svg class="icon icon-xxs">
                            <use xlink:href="/assets/img/icon-sprite.svg#global.collapse" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                          </svg>
                          {{ __('lang.global.product.tabs.accessories') }} {{ __('lang.global.to') }} {{ row.item.ref_no }}
                        </button>
                      </p>
                    </span>
                    </template>
                    <template #cell(info)="row">
                        <div class="text-center">
                            <button role="button" @click="row.toggleDetails"
                                    :class="row.detailsShowing ?  'btn m-0 p-0 text-primary' : 'btn m-0 p-0 text-primary collapsed'"
                                    data-toggle="collapse" aria-expanded="true">
                                <svg class="icon">
                                    <use xlink:href="/assets/img/icon-sprite.svg#global.collapse"
                                         xmlns:xlink="http://www.w3.org/1999/xlink">
                                    </use>
                                </svg>
                            </button>
                        </div>
                    </template>
                    <template #row-details="row">
                        <div class="bg-white">
                            <div class="border-bottom">
                                <div class="container-fluid py-3">
                                    <!-- <b-button size="sm" @click="row.toggleDetails">Hide Details</b-button> -->
                                    <div class="row justify-content-center">
                                        <!--  <div class="col-2"><img class="img-fluid" :src="mediaserver_url + row.item.image" />
                                         </div> -->
                                        <div class="col-5 mt-n3">
                                            <!-- <p class="mb-0">{{row.item.type}}</p>
                                            <h5 class="mb-3">{{row.item.description_short}}</h5> -->
                                            <p>{{row.item.description_long}}</p>
                                            <ul class="list-unstyled downloads">
                                                <li class="mb-1">
                                                    <router-link
                                                        :to="{ name: 'productdetail', query: query_params(row.item.ref_no,row.item.product_child_version,0)}"
                                                        class="text-primary font-weight-bold" role="button" target="_blank">
                                  <span @click.prevent="opendetail(row.item.ref_no,row.item.product_child_version,0)"
                                        role="link">
                                    <svg class="icon">
                                      <use xlink:href="/assets/img/icon-sprite.svg#global.external-link"
                                           xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                    </svg>{{__('lang.global.product.downloads.toproductdetailpage')}}
                                  </span>
                                                    </router-link>
                                                </li>
                                                <li :class="(row.item.datasheet=='undefined' || !row.item.datasheet) ? 'd-none':'mb-1' ">
                                                    <a class="text-primary font-weight-bold" :href="mediaserver_url + row.item.datasheet"
                                                       target="_blank" role="button">
                                                        <svg class="icon">
                                                            <use xlink:href="/assets/img/icon-sprite.svg#global.file.pdf"
                                                                 xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                                        </svg>{{__('lang.global.product.downloads.datasheet')}}</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bg-white pl-8 small">
                            <!--  <button v-b-toggle="'collapse-' + row.item.ref_no"
                               :class="!row.item.items ?'d-none' :'btn btn-link btn-sm p-0'"
                               @click="$event.target.classList.toggle('collapsed')" data-toggle="collapse" aria-expanded="true">
                               <svg class="icon icon-xxs">
                                 <use xlink:href="/assets/img/icon-sprite.svg#global.collapse"
                                   xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                               </svg>
                               {{__('lang.global.product.tabs.accessories')}} {{__('lang.global.to')}} {{row.item.ref_no}}
                             </button>

                             <b-collapse :id="'collapse-'+ row.item.ref_no" class="mt-2 border-bottom"> -->



                            <p :class="!row.item.items ? 'd-none' : 'font-weight-bold pt-1'">{{ __('lang.global.product.tabs.accessories') }} {{ __('lang.global.to') }} {{ row.item.ref_no }}</p>
                            <b-table class="table table-striped table-borderless table-responsive-md nesteditemsrow"
                                     thead-tr-class="d-none" details-td-class="p-0" striped borderless responsive="md"
                                     :items="row.item.items" :fields="table_fields" sort-icon-left>
                                <template #cell(image)="row2">
                            <span v-show="row2.item.image && row2.item.image!=='undefined' && row2.item.image!==''">
                              <router-link
                                  :to="{ name: 'productdetail', query: query_params(row2.item.ref_no, row2.item.product_child_version, 0) }"
                                  role="button" target="_blank">
                                <span @click.prevent="opendetail(row2.item.ref_no, row2.item.product_child_version, 0)" role="link">
                                  <b-img class="img-td-small-3" :src="row2.item.image ? mediaserver_url + row2.item.image : ''" fluid alt=""></b-img>
                                </span>
                              </router-link>
                            </span>
                                </template>
                                <template #cell(type)="typerow">


                                <span>
                                  <router-link :to="{ name: 'productdetail', query: query_params(typerow.item.ref_no, typerow.item.version, 1, typerow.item.execution) }"
                                               class="text-primary" role="button" target="_blank">
                                    <span @click.prevent="opendetail(typerow.item.ref_no, typerow.item.version, 1, typerow.item.execution)" role="link">{{ typerow.item.type }}</span>
                                  </router-link>
                                </span>
                                    <br>
                                    {{ typerow.item.description_short }}

                                </template>
                                <template #cell(info)="row2">
                                    <button role="button" @click="row2.toggleDetails"
                                            :class="row2.detailsShowing ?  'btn m-0 p-0 text-primary' : 'btn m-0 p-0 text-primary collapsed'"
                                            data-toggle="collapse">
                                        <svg class="icon">
                                            <use xlink:href="/assets/img/icon-sprite.svg#global.collapse"
                                                 xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                        </svg>
                                    </button>
                                </template>
                                <template #row-details="row2">

                                    <div class="bg-white">

                                        <div class="border-bottom">
                                            <div class="container-fluid py-3">
                                                <div class="row justify-content-center">
                                                    <!-- <div class="col-2"><img class="img-fluid" :src="mediaserver_url + row2.item.image" />
                                                    </div> -->
                                                    <div class="col-6 mt-n3">
                                                        <!-- <p class="mb-0">{{row2.item.type}}</p>
                                                        <h5 class="mb-3">{{row2.item.description_short}}</h5> -->
                                                        <p>{{row2.item.description_long}}</p>
                                                        <ul class="list-unstyled downloads">
                                                            <li class="mb-1">
                                                                <router-link
                                                                    :to="{ name: 'productdetail', query: query_params(row2.item.ref_no,row2.item.product_child_version,0)}"
                                                                    class="text-primary font-weight-bold" role="button" target="_blank">
                                          <span
                                              @click.prevent="opendetail(row2.item.ref_no,row2.item.product_child_version,0)"
                                              role="link">
                                            <svg class="icon">
                                              <use xlink:href="/assets/img/icon-sprite.svg#global.external-link"
                                                   xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                            </svg>{{__('lang.global.product.downloads.toproductdetailpage')}}
                                          </span>
                                                                </router-link>
                                                            </li>
                                                            <li :class="!row2.item.datasheet ? 'd-none' :'mb-2'"><a
                                                                class="text-primary font-weight-bold"
                                                                :href="mediaserver_url + row2.item.datasheet" target="_blank" role="button">
                                                                <svg class="icon">
                                                                    <use xlink:href="/assets/img/icon-sprite.svg#global.file.pdf"
                                                                         xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                                                </svg>{{__('lang.global.product.downloads.datasheet')}}</a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </template>
                            </b-table>
                            <!--  </b-collapse> -->
                        </div>
                    </template>
                </b-table>



            </div>
          </li>

          <li class="nav-item w-100" v-if="product_data.flag_fan==2"><a
            class="nav-link px-0 d-flex align-items-center justify-content-between border-bottom collapsed h4 text-gray-50 font-weight-light"
            data-toggle="collapse" href="#collapseParents" aria-expanded="false" aria-controls="collapseParents"
            role="button" @click="getProductParents"><span
              class="col-auto">{{__('lang.global.product.tabs.suitable')}}</span><span class="col-auto pl-3">
              <svg class="icon icon-sm m-0">
                <use xlink:href="/assets/img/icon-sprite.svg#global.collapse" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
              </svg></span></a>
            <div class="collapse" id="collapseParents" data-parent="#accordion">

              <b-table class="table table-striped table-borderless table-responsive-md" striped borderless responsive="md"
                details-td-class="p-0" :items="productparents" :fields="table_fields" sort-icon-left>
                <template #cell(ref_no)="row">
                  {{row.item.ref_no}}-{{row.item.version}}
                </template>
                <template v-slot:cell(type)="row">
                  {{row.item.type}}<br/>
                  <!-- <span>
                              <router-link :to="{ name: 'productdetail', query: query_params(row.item.ref_no, row.item.version,0)}" class="text-primary"
                                role="button" target="_blank">
                                <span @click.prevent="opendetail(row.item.ref_no, row.item.version,0)" role="link">{{row.item.type}}</span>
                              </router-link>
                            </span><br> -->
                  <span class="small text-primary" v-if="row.item.state.toLowerCase()=='v'">{{__('lang.product.text.old')}}</span>
                </template>
                <template #cell(info)="row">
                  <div class="text-center">
                    <button role="button" @click="row.toggleDetails"
                      :class="row.detailsShowing ?  'btn m-0 p-0 text-primary' : 'btn m-0 p-0 text-primary collapsed'"
                      data-toggle="collapse">
                      <svg class="icon">
                        <use xlink:href="/assets/img/icon-sprite.svg#global.collapse" xmlns:xlink="http://www.w3.org/1999/xlink">
                        </use>
                      </svg>
                    </button>
                  </div>
                </template>
                <template #row-details="row">
                  <div class="bg-white">
                    <div class="border-bottom">
                      <div class="container-fluid py-3">
                        <!-- <b-button size="sm" @click="row.toggleDetails">Hide Details</b-button> -->
                        <div class="row justify-content-center">
                          <div class="col-2"><img v-show="row.item.image && row.item.image!=='undefined' && row.item.image!==''" class="img-fluid" :src="mediaserver_url + row.item.image" alt=""/></div>
                          <div class="col-7">
                            <p class="mb-0">{{row.item.type}}</p>
                            <h5 class="mb-3">{{row.item.description_short}}</h5>
                            <p>{{row.item.description_long}}</p>
                            <ul class="list-unstyled downloads">
                              <li class="mb-1">
                                <router-link :to="{ name: 'productdetail', query: query_params(row.item.ref_no,row.item.version,0)}"
                                  class="text-primary font-weight-bold" role="button" target="_blank">
                                  <span @click.prevent="opendetail(row.item.ref_no,row.item.version,0)" role="link">
                                    <svg class="icon">
                                      <use xlink:href="/assets/img/icon-sprite.svg#global.external-link"
                                        xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                    </svg>{{__('lang.global.product.downloads.toproductdetailpage')}}
                                  </span>
                                </router-link>
                              </li>
                              <li :class="(row.item.datasheet=='undefined' || !row.item.datasheet) ? 'd-none':'mb-1' "><a
                                  class="text-primary font-weight-bold" :href="mediaserver_url + row.item.datasheet" target="_blank"
                                  role="button">
                                  <svg class="icon">
                                    <use xlink:href="/assets/img/icon-sprite.svg#global.file.pdf"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                  </svg>{{__('lang.global.product.downloads.datasheet')}}</a></li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </template>
              </b-table>
            </div>
          </li>




<!--            <li class="nav-item w-100" v-if="user.auth" ><a

              class="nav-link px-0 d-flex align-items-center justify-content-between border-bottom collapsed h4 text-gray-50 font-weight-light"
              data-toggle="collapse" href="#collapseCadenas" aria-expanded="false" aria-controls="collapseCadenas"
              role="button" @click="loadIframeCadenas()"><span
                  class="col-auto">{{ __('lang.global.product.tabs.cadenas') }}</span><span class="col-auto pl-3">
                  <svg class="icon icon-sm m-0">
                    <use xlink:href="/assets/img/icon-sprite.svg#global.collapse"
                      xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                  </svg></span></a>


                  <div class="collapse" id="collapseCadenas" data-parent="#accordion">
                    <div class="container">
                      <div class="row py-3">
                        <div class="col-12">
                          <iframe  class="embed-responsive-item" id="iframeCadenas" :src="iframeCadenas.src"  allowfullscreen loading="lazy" style="width:100%;height:40rem"></iframe>
                        </div>
                      </div>
                    </div>
                  </div>


                </li>
  <li v-else class="nav-item ml-md-3" role="presentation">
                  <p class="h4 text-gray-50 font-weight-light" style="display: block; padding: .5rem 1rem 0rem 1rem !important;">{{ __('lang.global.product.tabs.cadenas') }}
                    <span class="p-0 small text-gray-50 font-weight-light text-center" style="font-size:.8rem">{{ __('lang.message.loginrequired') }}</span>
                  </p>
                </li>-->




        </ul>


      </div>
    </div>
  </div>
</template>

<script>
    import productdetailhighcharts  from './ProductDetailHighcharts'
    //import globalsApi from './services/api/globals'
    import productdataApi from './services/api/productdataAPI.js'




export default {
      components: {
		       productdetailhighcharts
        },
      computed: {
          product_data:{
              get () {
                return this.$store.state.productdata.product_data
              }
          },
          product_media:{
            get(){
              return this.$store.state.productdata.product_media
            },
            set(value){
              this.$store.commit('productdata/setMediaData',value);

            }
          },
          accessories:{
            get(){
              return this.$store.state.productdata.accessories
            },
            set(value){
              this.$store.commit('productdata/setAccessories',value);

            }
          },
          table_fields: {
            get () {
              return this.setFieldLabels(this.$store.state.productdata.table_fields)
            }
          },
          table_fields_download: {
            get () {
              return this.setFieldLabels(this.$store.state.productdata.table_fields_download)
            }
          },
          lvtext:{
            get () {
                return this.$store.state.productdata.lvtext
              }
          },
          /*  media_dir : {
            get () {
                return this.$store.state.productdata.media_dir
            }
          },
          op : {
            get () {
                return this.$store.state.operatingpoint.op
            }
          },*/
          op : {
            get () {
                return this.$store.state.productdata.op
            }
          },
          /* table_fields_techproperties:  {
            get() {
              console.log(this.setFieldLabels(this.$store.state.productdata.table_fields_techproperties))
              return this.setFieldLabels(this.$store.state.productdata.table_fields_techproperties)
            }
          }, */

          table_fields_acoustics: {
                get () {
                  return this.setFieldLabels(this.$store.state.productdata.table_fields_acoustics)
                }
          },


          max_temp: function () {
              return Math.max(this.product_data.temp_controlled,this.product_data.temp_uncontrolled)
          },
          voltage: function (){
            var v1=this.product_data.voltage1??0
            var v2=this.product_data.voltage2 ?? 0
            var phase=this.product_data.phase ?? 0
            var f1=this.product_data.frequency1 ?? 0
            var f2=this.product_data.frequency2 ?? 0

            /*var return_str = (v1 > 0 ? v1 : '') + ((v1 > 0 && v2 > 0) ? ' ' +this.__('lang.units.volt') + ' / '  :'')+(v2>0 ? v2 :'') + ((v1>0 || v2>0) ? ' '+this.__('lang.units.volt') +' / ':'')+
                            (phase>0? phase + ' '+this.__('lang.units.ph')+' / ' :'')+(f1>0 ? f1 :'')+((f1>0 && f2>0) ? ' / ':'')+(f2>0 ? f2 :'')+((f1>0 || f2>0) ? this.__('lang.units.hz') :'')*/
            var return_str = (v1 > 0 ? v1 : '') + ((v1 > 0 && v2 > 0) ? ' '  + ' / ' : '') + (v2 > 0 ? v2 : '') + ((v1 > 0 || v2 > 0) ? ' ' + this.__('lang.units.volt')  : '') +
                              (phase > 0 ? (v1 > 0 || v2 > 0 ? ' , ' : '') + phase + ' ' + this.__('lang.units.ph')  : '') +
                              (f1 > 0 ? (v1 > 0 || v2 > 0 || phase > 0 ? ' , ' : '') + f1 : '') + ((f1 > 0 && f2 > 0) ? ' / ' : '') +
                              (f2 > 0 ? (((v1 > 0 || v2 > 0 || phase > 0) && f1==0) ? ' , ' : '') + f2 : '') + ((f1 > 0 || f2 > 0) ? ' ' + this.__('lang.units.hz') : '')
            return return_str
          },

          rpm: function (){
                  var rpm1=this.product_data.rpm1 ?? 0
                  var rpm2 =this.product_data.rpm2 ?? 0
                  var return_str = (rpm1 > 0 ? rpm1 : '') + ((rpm1 > 0 && rpm2 > 0) ? ' '  + ' / ' : '') + (rpm2 > 0 ? rpm2 : '') + ((rpm1 > 0 || rpm2 > 0) ? ' ' + this.__('lang.units.rpm')  : '')

                  return return_str

          },

          ppz: function () {
            var ppz1 = this.product_data.ppz1 ?? 0
            var ppz2 = this.product_data.ppz2 ?? 0
            var return_str = (ppz1 > 0 ? ppz1 : '') + ((ppz1 > 0 && ppz2 > 0) ? ' ' + ' / ' : '') + (ppz2 > 0 ? ppz2 : '')

            return return_str

          },

          flc_uncontrolled: function () {
            var flcu1 = this.product_data.flc_uncontrolled1 ?? 0
            var flcu2 = this.product_data.flc_uncontrolled2 ?? 0
            var return_str = (flcu1 > 0 ? flcu1 : '') + ((flcu1 > 0 && flcu2 > 0) ? ' ' + ' / ' : '') + (flcu2 > 0 ? flcu2 : '') + ((flcu1 > 0 || flcu2 > 0) ? ' ' + this.__('lang.units.amper') : '')

            return return_str

          },

          power: function () {
            var power1 = this.product_data.power1 ?? 0
            var power2 = this.product_data.power2 ?? 0
            var unit =  this.__('lang.units.watt')
            if (power1 > 100 || power2 > 100) {
              power1 = power1 / 1000
              power2 = power2 / 1000
              unit= this.__('lang.units.kilowatt')
            }
            var return_str = (power1 > 0 ? power1 : '') + ((power1 > 0 && power2 > 0) ? ' ' + ' / ' : '') + (power2 > 0 ? power2 : '') + ((power1 > 0 || power2 > 0) ? ' ' + unit : '')

            return return_str

          },
          speedcontrol_type: function () {

            var sptype = this.product_data.speedcontrol_type
            const  sptype_arr = sptype.split(';')

            var return_arr=[]
            sptype_arr.forEach(function (sp) {
              //return_str = return_str + this.__('lang.'+ sp) + '/'
              return_arr.push(this.__('lang.' + sp.trim()));
            }.bind(this))
            var return_str = return_arr.join(' / ');

            return return_str


          },
          heat_exchanger_type: function () {
            var value = this.product_data.heat_exchanger_type
            return this.__('lang.' + value);


          },
          device_execution: function () {
            var value = this.product_data.device_execution
            return this.__('lang.' + value);
          },
          assembly_position: function () {
            var value = this.product_data.assembly_position
            return this.__('lang.' + value);


          },


         /*  stc_uncontrolled: function () {
                var max_stc = Math.max(this.product_data.flc_uncontrolled1,this.product_data.flc_uncontrolled2)
                return  parseFloat( max_stc*this.product_data.factor_stc_uncontrolled).toFixed(2)


          }, */
          abst_lpa:{
            get() {

              return this.$store.state.productdata.acoustics.abst_lpa
            }
          },
          acoustics: {
            get() {
              return this.$store.state.productdata.acoustics
            },
          },
            /*
          acoustics: function () {

            var acousticsdata = this.$store.state.productdata.acoustics
            var acoustics = []
            if(this.$store.state.productdata.acoustics.fldss_ges>0){
              var acoustics_ss= Object.keys(acousticsdata).filter((key) => key.includes('fldss')).
                reduce((cur, key) => { return Object.assign(cur, { [key.replace("fldss", "oktav")]: acousticsdata[key] })}, {});
                acoustics_ss=Object.assign({acoustictype: 'S_SS'}, acoustics_ss);
              acoustics.push(acoustics_ss);
            }
            if(this.$store.state.productdata.acoustics.fldds_ges>0){
              var acoustics_ds= Object.keys(acousticsdata).filter((key) => key.includes('fldds')).
                reduce((cur, key) => { return Object.assign(cur, { [key.replace("fldds", "oktav")]: acousticsdata[key] })}, {});
                acoustics_ds=Object.assign({acoustictype: 'S_DS'}, acoustics_ds);
              acoustics.push(acoustics_ds);
            }
            if(this.$store.state.productdata.acoustics.fldab_ges>0){
              var acoustics_ab= Object.keys(acousticsdata).filter((key) => key.includes('fldab')).
                reduce((cur, key) => { return Object.assign(cur, { [key.replace("fldab", "oktav")]: acousticsdata[key] })}, {});
                acoustics_ab=Object.assign({acoustictype: 'S_AB'}, acoustics_ab);
              acoustics.push(acoustics_ab);
            }

            return acoustics
          },
          */
          acousticdistance: {
            get() {
              return this.$store.state.productdata.AcousticDistanceData
            }
          },
          acousticpoints: function() {

            var acousticpoints = this.acoustics.filter(item => item.acoustictyp == 'lwa') //.map(function (point) { return point.pointnr })


            var uniqueacousticpoints = [...new Set(acousticpoints.map(obj => obj.pointnr))];
           /* console.log('acousticpoints uniqueacousticpoints:')
            console.log(uniqueacousticpoints)*/
            return uniqueacousticpoints

          },

          acousticslwa: function () {
            var acoustics = this.acoustics
            var acousticslwa = []
            var pressure


            var acousticpoints = acoustics.filter(item => item.acoustictyp == 'lwa')
            var uniqueairtyp = [...new Set(acousticpoints.map(obj => obj.airtyp))];
            var uniqueacousticpoints = [...new Set(acousticpoints.map(obj => obj.pointnr))];
            var p_head = {}

            var table_fields_acousticslwa = [{ key: 'acoustictyp', label: '' }]
            var units = {
              volumenflow: this.__('lang.units.airflow_volume'),
              pressure: this.__('lang.units.pressure'),
            }



            uniqueairtyp.forEach(function (airtyp) {
              var p = {}
              uniqueacousticpoints.forEach(function (point) {
                var airtyprow = acoustics.filter(item => item.acoustictyp == 'lwa' && item.airtyp === airtyp && item.pointnr === point)
                airtyprow.forEach(function (el) {
                  p = Object.assign(p, {
                    ['hz_' + point]: el.hz_sum
                  })

                  p_head = Object.assign({}, {
                    key: 'hz_' + point ,
                    label: el.volumenflow.toString() + ' ' + units.volumenflow
                  })
                  pressure = el.pressure

                  table_fields_acousticslwa.push(p_head)
                })
              })
              var o = Object.assign({}, {
                acoustictyp: 'lwa',
                airtyp: airtyp,
              }, p)
              acousticslwa.push(o)
            })

            var uniqueheadlwa = [...new Map(table_fields_acousticslwa.map(item => [item['key'], item])).values()];
            this.table_fields_acousticslwa = uniqueheadlwa
            this.lwapoint_pressure = pressure


           /* console.log(acousticslwa)*/
            return acousticslwa

          },
          acousticslpa: function () {
            var acoustics = this.acoustics
            var acousticslpa = []
            var acousticdistance = this.acousticdistance
            var p = {}

            var acousticpoints = acoustics.filter(item => item.acoustictyp == 'lwa' && item.airtyp === 'radiation')

            var uniqueacousticpoints = [...new Set(acousticpoints.map(obj => obj.pointnr))];


            var productacousticdistance = [...new Set(acoustics.map(obj => obj.distance))];  //return ["1;3;5"]
            var distance_arr = productacousticdistance.toString().split(';')
            distance_arr.forEach(function (el) {

              var ad = parseFloat(acousticdistance.filter(distance => parseFloat(distance.distance) == parseFloat(el)).map(o => o.dba)[0]) // dba


              uniqueacousticpoints.forEach(function (point) {

                var acousticslpa = acousticpoints.filter(item => item.acoustictyp == 'lwa' && item.airtyp == 'radiation' && item.pointnr == point).map(dba => dba.hz_sum)[0]
                console.log('acousticslpa')
                console.log(acousticslpa)
                p = Object.assign(p, {
                  ['hz_' + point]: acousticslpa - ad,
                  meter: el

                })
              })
                console.log('ad')
                console.log(ad)

                console.log('p')
                console.log(p)

              var o = Object.assign({}, {
                acoustictyp: 'lpa',
                airtyp: 'radiation',
              }, p)
              acousticslpa.push(o)




            })
            return acousticslpa

          },

          soundinduct: function () {
            //var total=Math.round(this.$store.state.productdata.acoustics.fldss_ges);
            let productacousticdistance = 0,
                total = 0,
                acousticdeduction = 0


            productacousticdistance = Math.round(this.acoustics.filter(item => item.acoustictyp == 'lwa' && (item.airtyp == 'inlet' || item.airtyp == 'supply' ) && item.pointnr == 1).map(function (inlet) { return inlet.distance })[0]).toFixed(0)
            total = Math.round(this.acoustics.filter(item => item.acoustictyp == 'lwa' && (item.airtyp == 'inlet' || item.airtyp == 'supply') && item.pointnr == 1).map(function (inlet) { return inlet.hz_sum })[0]).toFixed(0)

            if(productacousticdistance>0)
            acousticdeduction = Math.round(this.acousticdistance.filter(item => item.distance == productacousticdistance).map(function (dba) { return dba.dba })[0]).toFixed(0)



            /* var soundinduct = {
              lwa: total > 0 ? total - (parseInt(productacousticdistance) == 4 ? 20 : 8) : '',
              distance: total > 0 && productacousticdistance > 0 ? productacousticdistance : total > 0 ? 1 : ''
            } */

            var soundinduct = {
              lwa: total > 0 ? total - acousticdeduction : '',
              distance: total > 0 && productacousticdistance > 0 ? productacousticdistance : total > 0 ? 0 : ''
            }

            return soundinduct
          },
          casebreakout: function () {
            let productacousticdistance = 0,
              total = 0,
              acousticdeduction = 0
                /* var total=Math.round(this.$store.state.productdata.acoustics.fldab_ges)
                return total> 0 ? total - (parseInt(this.$store.state.productdata.acoustics.abst_lpa)==4 ? 20 : 8) :'' */
            productacousticdistance = Math.round(this.acoustics.filter(item => item.acoustictyp == 'lwa' && item.airtyp == 'radiation' && item.pointnr == 1).map(function (radiation) { return radiation.distance })[0]).toFixed(0)
            total = Math.round(this.acoustics.filter(item => item.acoustictyp == 'lwa' && item.airtyp == 'radiation' && item.pointnr == 1).map(function (radiation) { return radiation.hz_sum })[0]).toFixed(0)
            if (productacousticdistance > 0)
                acousticdeduction = Math.round(this.acousticdistance.filter(item => item.distance == productacousticdistance).map(function (dba) { return dba.dba })[0]).toFixed(0)

            var casebreakout = {
              lwa: total > 0 ? total - acousticdeduction : '',
              distance: total > 0 && productacousticdistance > 0 ? productacousticdistance : total > 0 ? 0 : ''
            }
            return casebreakout
          },
          media_ssplan:function() {
                var ssplan=''
                if(this.product_media.filter(item => item.media_type == 'ssplan' && item.filename !='').length > 0){
                    var ssplan = this.product_media.filter(item => item.media_type == 'ssplan')[0]
                    if(ssplan!='undefined') ssplan = ssplan.path +  '/' + ssplan.filename

                }
                return ssplan

                //return this.$parent.getMediaSrc('ssplan')
                //return this.getMediaSrc('ssplan')

          },
          media_dimension:function() {
              var dimension=''
              if(this.product_media.filter(item => item.media_type == 'dimension' && item.filename !='').length > 0 && item.f_download==1) {
                  var dimension = this.product_media.filter(item => item.media_type == 'dimension')[0]
                  if(dimension!='undefined') dimension = dimension.path +  '/' + dimension.filename

              }
              return dimension
              //return this.$parent.getMediaSrc('dimension')
              //return this.getMediaSrc('dimension')

          },
          media_dimension_svg:function () {
            var svg
            if(this.product_media.filter(item => item.f_download==0 && item.media_type == 'dimension' && item.filename !='').length > 0){
              var dimension = this.product_media.filter(item => item.f_download==0 && item.media_type == 'dimension')[0]
              if(dimension!='undefined') svg = dimension.path + this.media_dim_path + dimension.filename
            }
            return svg

          },
          media_lvtext: function() {
              //return this.$parent.getMediaSrc('lvtext')
              var lvtext=''
              if(this.product_media.filter(item => item.media_type == 'lvtext' && item.filename !='').length > 0){
                  var lvfile = this.product_media.filter(item => item.media_type == 'lvtext')[0]
                  if(lvfile!='undefined') lvtext = lvfile.path +  '/' + lvfile.filename
                  lvtext.replaceAll(/(?<!:)\/+/gm, '/');
              }
              return lvtext
          },
          /* mediaData: {
            get () {
              return this.$store.state.productdata.mediaData
            }
          } */
          units_selected: function(){
            var airflowunits_selected=this.op.airflowunits??1
            var pressureunits_selected=this.op.pressureunits??5
            var units_selected={
              airflowunits:this.__(this.$store.state.operatingpoint.op.airflowunits_options.find(o => o.value == airflowunits_selected).text),
              pressureunits:this.__(this.$store.state.operatingpoint.op.pressureunits_options.find(o => o.value == pressureunits_selected).text)
            }
            return units_selected

          },
          session: {
            get () {
              return this.$store.state.user.session
            },
            set (value) {
                  this.$store.commit('user/updateSession', value)
              }
          },
          user: {
            get () {
              return this.$store.state.user.user
            },
            set (value) {
                  this.$store.commit('user/updateUser', value)
              }
          },


          productitems: function () {

            const proddata_stored = this.$store.state.productdata.product_data
            var productitems =  []

            //if op show this in techdata :  values in units_selected
            var proddata_op=this.$store.state.productdata.op
            Object.assign(proddata_stored ,{op_volumeflow:proddata_op.op_volumeflow, op_pressure:proddata_op.op_pressure, op_angle:Math.round(proddata_op.op_angle)});


            //resolve the reference to proddata_stored
            //first Object to string:
            var proddata_str = JSON.stringify(proddata_stored);
            //second String to object:
            var proddata = JSON.parse(proddata_str);



           /*  var techproperties_arr_of_obj = this.$store.state.productdata.techproperties
            var techproperties = techproperties_arr_of_obj.map(function (el) { return el.key; }); */

            //labels:
            var techproperties_header = this.$store.state.productdata.table_fields_techproperties
            var techproperties = techproperties_header.map(function (el) { return el.key; });

            //delete all arrays with not technical values (media, childs,...), nulls,
            Object.keys(proddata).forEach(key => {

              if ((!techproperties.includes(key) || (proddata[key] === null || proddata[key] == 'NULL' || proddata[key] == 'undefined' || proddata[key] === 0 || proddata[key] === '0' || proddata[key] === '' || Array.isArray(proddata[key])))) {
                techproperties_header = techproperties_header.filter(x => x.key!== key); //remove el from header
                delete proddata[key];
              }
            });
            /* if not exist in proddata max_angle=> remove  op_angle*/
              if (!proddata['max_angle']) {
                  delete proddata['op_angle'];
                  techproperties_header = techproperties_header.filter(x => x.key!== 'op_angle'); //remove el op_angle from header
              }


            /*
            var techproperties_arr = this.$store.state.productdata.techproperties_arr
            Object.keys(proddata).forEach(key => {

              if ((!techproperties_arr.includes(key) || (proddata[key] === null || proddata[key] == 'NULL' || proddata[key] == 'undefined' || proddata[key] === 0 || proddata[key] === '0' || proddata[key] === '' || Array.isArray(proddata[key])))) {
                delete proddata[key];
              }
            }); */
            //convert obj proddata to array[[],[],....]
            const techdata = Object.entries(proddata)

            if (techdata.length > 0){
              // if lang key not found => take 'global.product' => 'Artikel',
             //-- var techdatarow = Object.assign(...techdata.map(([k, v]) => ({ [this.__('lang.global.product.tabs.techdata.' + k) !== 'Artikel' ? this.__('lang.global.product.tabs.techdata.' + k) : k]: v })));
//              var techdatarow = Object.assign(...techdata.map(([k, v]) => ({ [this.__(techproperties[k])]: v })));

              //console.log(techproperties_arr_of_obj.find(x => x.key === 'ref_no'))

              //var techdatarow = Object.assign(...techdata.map(([k, v]) => ({ [this.__(techproperties_arr_of_obj.find(x=>x.key==='ref_no')).label]: v })));
             /*  var techdatarow = Object.assign(...techdata.map(function ([k,v] , index) {
                return Object.assign({}, { [this.__(techproperties_arr_of_obj.find(x => x.key === k).label)]: v })

              })) */

              var techdatarow = Object.assign(...techdata.map(([k, v], index) => (
               // { [this.__(techproperties_arr_of_obj.find(x => x.key === k).label)]: v + ' ' + this.__(techproperties_arr_of_obj.find(x => x.key === k).unit) })

                { [k]: v + ' ' + (k=='op_volumeflow'?this.units_selected.airflowunits: (k=='op_pressure'?this.units_selected.pressureunits : this.__(techproperties_header.find(x => x.key === k).unit) ))})
              ))



              productitems.push(techdatarow)
            }
            /*
            console.log('productitems:')
            console.log(productitems.items)
            */

            techproperties_header.sort(((a, b) => a.sort - b.sort))
            this.table_fields_techproperties = this.setFieldLabels(techproperties_header)

            return productitems
          },


        selectedlocale: {
            get() {
              return this.$store.state.user.selectedlocale
            },
            set(value) {
              this.$store.commit('user/updateSelectedlocale', value)
            }
        },
       /*  keyedAccessoriesItems() {
          return this.accessories.map((item, index) => {
            console.log(item)
           // if(item.items.length>0) item.items.map((subitem, i) => { return { ...subitem, idx: `${subitem.ref_no}_${i}` }; })

            return { ...item, idx: `${item.ref_no}_${index}` };
          })
        }  */


        },
        /*
        filters: {
          capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
          }
        },
        */

        data() {
          return {
            isActive: false,
            mediaserver_url:'',//'https://globalstest.heliosventilatoren.de' ,
            media_dim_path: 'svg/',
            table_fields_acousticslwa: [],
            lwapoint_pressure: '',
            productparents: [],
            productstate: 0,
            table_fields_techproperties: [],
           /*  checkprops: { blank: true, blankColor: '#0f0', width: 10, height: 10, class: 'm1' } */

            iframeCadenas: {
              src: ''

            },
            iframeResizerOptions: {
              sendMessage: true,
              checkOrigin: false,
              heightCalculationMethod: 'lowestElement',
              log: true,
              resizeFrom: 'parent',
              autoResize: true,
              bodyMargin: 0,
              bodyPadding: 0,
              scrolling: true,
              widthCalculationMethod:'rightMostElement'
              // Add more options as needed
               /*minWidth: 600,*/
            },



          }
		    },
  methods: {
/*
      async copyLVText() {
          const lvtextObject = document.getElementById('lvtextObject');
          console.log(lvtextObject.data);
          try {
              // Fetch the content of the file
              const response = await fetch(lvtextObject.data);
              const content = await response.text();

              // Write the content to the clipboard
              await navigator.clipboard.writeText(content);
              console.log('copy lvtext')
                /*--
              // Optionally, provide user feedback (e.g., a notification)
              this.$notify({
                  title: 'Success',
                  message: 'Formatted text copied to clipboard!',
                  type: 'success',
              });
              --

          } catch (err) {
              console.error('Unable to copy text to clipboard', err);
              /*--
              // Optionally, provide error feedback
              this.$notify({
                  title: 'Error',
                  message: 'Unable to copy text to clipboard',
                  type: 'error',
              });
              --
          }
      },*/

    sendMessageToIframe() {
      const iframe = this.$refs.iframeCadenasRef;
      if (iframe && iframe.iFrameResizer) {
        // Send a message to the iframe's content window
        iframe.iFrameResizer.sendMessage('Hello from parent!');
      }
    },

    //--openloginframe: function () {

          //  console.log(document.getElementsByClassName("myhelios")[0].getAttribute('aria-expanded'))
      /* document.getElementsByClassName("myhelios")[0].setAttribute('aria-expanded', 'true')

      //  document.getElementsByClassName("myhelios")[0].dropdown()
      console.log(document.getElementsByClassName("myhelios")[0].getAttribute('aria-expanded')) */
      //document.getElementsByClassName("myhelios")[0].click()
/*
       const buttonmyhelios = document.getElementsByClassName("myhelios")[0];

      //console.log(buttonmyhelios.getAttribute('aria-expanded'))
      //    buttonmyhelios.addEventListener('click', function () {
            var value = document.getElementsByClassName("myhelios")[0].getAttribute("aria-expanded");
            var content = document.getElementById("dropdown-login");

            if (value == "true") {
              buttonmyhelios.setAttribute("aria-expanded", "false");
              content.setAttribute("hidden", "");
            } else {
              buttonmyhelios.setAttribute("aria-expanded", "true");
              content.removeAttribute("hidden");
            }
         //});
        //  console.log(buttonmyhelios.getAttribute('aria-expanded'))


      //console.log(this.$root.$refs.dropdownlogin.needLogin)
           */


          //--this.$root.$refs.dropdownlogin.openlogin();
          //--},
          opendetail(refno,version, flag_fan) {
            var query_params=this.query_params(refno,version, flag_fan)

            if(this.user.auth){
              axios.post('/user/access/token', {navigation: 1}).then(response => {
                        Object.assign(query_params,  {access_token:response.data.access_token});
                    }).catch(function (error) {
                    });
            }
            let routeData = this.$router.resolve({name: 'productdetail', query: query_params });
            window.open(routeData.href, '_blank');
          },

          query_params(refno,version, flag_fan){
              var query_params={
                  ref_no: refno,
                  version: version,
                  language_id: this.$lang().locale //navigator.language,
              }


              /*
              let routeData = this.$router.resolve({name: 'productdetail', query: query_params });
              window.open(routeData.href, '_blank');
              */
              return query_params

          },
          setFieldLabels: function(value){
            var array =[];
            var sortable = true
            const customkeys = [{ key: 'rpm1' }, { key: 'rpm2' }, { key: 'ppz1' }, { key: 'ppz2' }, { key: 'flc_uncontrolled1' }, { key: 'flc_uncontrolled2' }, { key: 'power1' }, { key: 'power2'}]


            for (var i = 0; i < value.length; i++) {
              if (customkeys.some(v => v.key === value[i].key)) {
                var k = value[i].key.slice(0, -1)

                value.push({ key: k, label: 'lang.global.product.tabs.techdata.'+ k , sort: value[i].sort, unit: value[i].unit})
              }
            }
            value.sort(((a, b) => a.sort - b.sort))


            for (var i = 0; i < value.length; i++){
              if (value[i] == 'idx') { return '' }
              else if(value[i].key=='price') {
                array.push({key: value[i].key, label: this.__(value[i].label), sortable: sortable, _showDetails:true, thClass: 'small border-bottom',
                  formatter: (value, key, item) => {
                    var price = parseFloat(value);
                    if (!this.user.auth) return this.__('lang.message.loginrequired');
                    else if (this.user.countries_price == '') return this.__('lang.global.onrequest');// + ' PreisLand unbekannt';
                    /*  else if (this.user.auth && (this.user.countries_price != this.selectedlocale.country || this.user.countries_price != this.user.countries_iso)) return this.__('lang.global.onrequest');// + ' fremdes Land'; */
                    else if (this.user.auth && this.user.countries_price != this.selectedlocale.country) return this.__('lang.global.onrequest');// + ' fremdes Land';
                    else return price > 0 ? price.toFixed(0) : this.__('lang.global.onrequest');
                  }
                })
              }
              else if(value[i].key=='acoustictyp'){
                 array.push({key: value[i].key, label: this.__(value[i].label), sortable: false, _showDetails:true, thClass: 'small border-bottom', tdClass: 'text-nowrap',
                  formatter: (value, key, item) => {
                    return this.__('lang.global.product.tabs.techdata.lwa') + ' '+ this.__('lang.global.product.tabs.techdata.'+ value);
                  }
                })
              }
              else if( value[i].key=='dba'){
                 array.push({key: value[i].key, label: this.__(value[i].label), sortable: false, _showDetails:true, thClass: 'small border-bottom',
                  formatter: (value, key, item) => {
                    return this.__('lang.global.product.tabs.techdata.dba');
                  }

                })
              }
              else if (value[i].key.substring(0, 3) == 'hz_') {
                array.push({
                  key: value[i].key, label: this.__(value[i].label), sortable: false, _showDetails: true, thClass: 'small border-bottom',
                  formatter: (value, key, item) => {
                    return value
                  }
                })
              }
              else if (value[i].key == 'voltage1' || value[i].key == 'voltage2' || value[i].key == 'phase' || value[i].key == 'frequency1' || value[i].key == 'frequency2' ||
                value[i].key == 'rpm1' || value[i].key == 'rpm2' ||
                value[i].key == 'ppz1' || value[i].key == 'ppz2' ||
                value[i].key == 'flc_uncontrolled1' || value[i].key == 'flc_uncontrolled2' ||
                value[i].key == 'power1' || value[i].key == 'power2') {
              }
              /*
             else if (value[i].key == 'speedcontrol_type') {
                array.push({
                  key: value[i].key, label: this.__(value[i].label), sortable: false, _showDetails: true, thClass: 'small border-bottom',
                  formatter: (value, key, item) => {
                    //return value.replace(';', '/');
                    return this.speedcontrol_type
                  }
                })
              } */
              else if (value[i].key == 'voltage' || value[i].key == 'speedcontrol_type' || value[i].key == 'device_execution' || value[i].key == 'heat_exchanger_type' || value[i].key == 'assembly_position' ||
                      value[i].key == 'rpm' || value[i].key == 'ppz' || value[i].key == 'flc_uncontrolled' || value[i].key == 'power') {

                array.push({
                  key: value[i].key, label: this.__(value[i].label), sortable: false, _showDetails: true, thClass: 'small border-bottom',
                  formatter: (value, key, item) => {
                    //return value.replace(';', '/');
                    return this[key]
                  }
                })
              }

              else if (value[i].key == 'delivery') {
                array.push({
                  key: value[i].key, label: this.__(value[i].label), sortable: sortable, sortByFormatted: sortable, _showDetails: true, thClass: 'small border-bottom',
                  formatter: (value, key, item) => {


                    if(isNaN(value.replace(/\D/g, '')) || value.replace(/\D/g, '').length==0)  return this.__('lang.delivery_a') // this.__('lang.delivery_'+ value.toLowerCase())
                    else return value.replace(/\D/g, '') + ' ' + this.__('lang.units.week_short')

                    //  return value
                  }
                })
              }
              else if (value[i].key == 'max_pressure') {
                 array.push({
                    key: value[i].key, label: this.__(value[i].label), sortable: sortable, sortByFormatted: sortable, _showDetails: true, thClass: 'small border-bottom',
                    formatter: (value, key, item) => {
                      if (isNaN(value)) return  parseFloat(value).toFixed(0) + ' ' + this.__('lang.units.pascal')

                    }
                  })
              }

              else {
                  if(value[i].key== 'info' || value[i].key== 'cloud') sortable=false
                  array.push({key: value[i].key, label: this.__(value[i].label), sortable: sortable, _showDetails:true, thClass: 'small border-bottom',
                    formatter: (value, key, item) => {
                      if(typeof value == "number") return Math.round(value);
                      else return value;
                    }
                  })
              }
              //console.log(value[i]);
            }


            return array;
          },
          getAcousticTotal: function(acoustictype){
            for(var i = 0; i < this.acoustics.length; i++){
              if(this.acoustics[i].acoustictype==acoustictype) return this.acoustics[i].total;
            }
          },
          async getProductDownloads(){
            var params={ref_no: this.product_data.ref_no,version: this.product_data.version}
            productdataApi.getProductMediadata(params)
              .then(response => {
                  this.product_media=response.data.productmediadata
              })
              .catch(function () {
                  console.log('getProductDownloads Error');
              });
          },
          async getProductCurves(){
            this.$refs.highcharttab.getProductCurves()
          },
          async getProductAccessories(){
            var params = { ref_no: this.product_data.ref_no, version: this.product_data.version, language_id: this.$lang().locale }
            this.accessories = []
            productdataApi.getProductAccessories(params)
              .then(response => {


                  // this.accessories = response.data.productaccessories
                  this.accessories=response.data.productaccessories.map((item, index) => {
                    return { ...item, idx: `${item.ref_no}_${index}` };
                  })
                   /*console.log('response.data.accessories this.accessories')
                  console.log(this.accessories)*/
              })
              .catch(function () {

                  console.log('getProductAccessories Error');
              });
          },
          async getProductParents() {
            var params = { ref_no: this.product_data.ref_no, version: this.product_data.version, language_id: this.$lang().locale }

            productdataApi.getProductParents(params)
              .then(response => {


                //--this.productparents = response.data.productparents


                this.productparents = response.data.productparents.map((item, index) => {
                  return { ...item, idx: `${item.ref_no}_${index}` };
                })
                /*console.log('response.data.productparents this.productparents')
                console.log(this.productparents)*/

              })
              .catch(function () {
                console.log('getProductParents Error');
              });
          },


         /*  getProductAcoustics(){
                var params={ref_no: this.product_data.ref_no,version: this.product_data.version}
                productdataApi.getProductAcoustics(params)
                    .then(responsacoustics => {
                        console.log('getProductAcoustics responsacoustics');
                        console.log(responsacoustics);
                        this.product_data.acoustics = responsacoustics.data.acoustics


                    })
                    .catch(function () {
                        console.log('getProductresponsAcoustics Error');
                    });
          },
             */

          isMobile() {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
            if ('maxTouchPoints' in navigator) {
              console.log('navigator.maxTouchPoints:');
              console.log(navigator.maxTouchPoints);
              return navigator.maxTouchPoints > 0 ? true : false
            }
            else {
              console.log('navigator test:');
              console.log(navigator.maxTouchPoints);

            }

          },
          /*
          isMobile() {
            var hasTouchScreen = false;
            if ("maxTouchPoints" in navigator) {
              console.log('maxTouchPoints:')
              console.log(navigator.maxTouchPoints)  //256????
              hasTouchScreen = navigator.maxTouchPoints > 0;
            } else if ("msMaxTouchPoints" in navigator) {
              console.log('msMaxTouchPoints:')
              console.log(navigator.msMaxTouchPoints)
              hasTouchScreen = navigator.msMaxTouchPoints > 0;
            } else {
              var mQ = window.matchMedia && matchMedia("(pointer:coarse)");
              if (mQ && mQ.media === "(pointer:coarse)") {
                hasTouchScreen = !!mQ.matches;
                console.log('mQ.matches:')
                console.log(mQ.matches)
              } else if ('orientation' in window) {
                console.log('orientation')

                hasTouchScreen = true; // deprecated, but good fallback
              } else {
                // Only as a last resort, fall back to user agent sniffing
                var UA = navigator.userAgent;
                hasTouchScreen = (
                  /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
                  /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA)
                );
                console.log('test:')

              }
            }
            console.log('hasTouchScreen:')
            console.log(hasTouchScreen)
            return hasTouchScreen;
          }
          */
          loadIframeCadenas() {
            //this.iframeCadenas.src = 'https://ipr-embedded.partcommunity.com/?catalog=ipr&part=150000976&iframe=true'
            /*catalog portal
            //this.iframeCadenas.src = 'https://heliosventilatoren.qa.partcommunity.com/3d-cad-models/sso/rr-radial-rohrventilator-1-ph-helios?info=helios%2Fhelios20ventilatoren%2Frohrventilatoren%2Frr.prj&cwid=0679&varset={ARTNR='+this.product_data.ref_no +'}'
            */
            /*embedded portal*/
            //this.iframeCadenas.src = "https://heliosventilatoren-embedded.qa.partcommunity.com/?catalog=helios&part=" + this.product_data.ref_no + "&languageIso="+ this.$lang().locale

            var params = { ref_no: this.product_data.ref_no, version: this.product_data.version, language_id: this.$lang().locale }

            productdataApi.getProductCadenas(params)
                .then(response => {
                  /*console.log('response.data.cadenassrc')
                   console.log(response.data)*/
                  this.iframeCadenas.src = response.data
                })
                .catch(function () {
                  console.log('getProductCadenas Error');
                });

            },



            getLongDesc(desc) {
              var str = ''
              if (desc != null) str = desc.replace(/(<([^>]+)>)/ig, '');
              return str.length > 255 ? str.substring(0, 255) + '...' : str;
            },
           /*
            getAccessoriesCount(prod)       {
              if (prod.items != null) return 'Zusatzteile!!!!'
            }, */
            loaded(){
                // activate characteristics tab and set tab title when the parameter is in url
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                const airflowrate = urlParams.get('airflowrate')
                const externalpressure = urlParams.get('externalpressure')



                //this.$refs.prodcurves.click();

                //setTimeout(() => {
                    if (airflowrate!=null && airflowrate>0 && externalpressure!=null && externalpressure>0) {
                        if (this.isMobile()) {
                            let allcollapsedivs = document.querySelectorAll('.collapse')

                            let curvesSpanTitle = document.getElementById('collapseCharacteristicsTitle');
                            curvesSpanTitle.textContent = this.__('lang.global.product.tabs.curveswithop')

                            allcollapsedivs.forEach((collapseDiv) => {
                                collapseDiv.classList.remove('show')
                            });

                            let curvesDiv = document.getElementById('collapseCharacteristics')
                            curvesDiv.classList.add('show');

                        } else {
                            let curvesTab = document.getElementById('characteristics-nav-tab')
                            let curvesTabPane = document.getElementById('characteristics-tab-pane')
                            let allTabPanes = document.querySelectorAll('.tab-pane')
                            let allLinksTabs = document.querySelectorAll('.nav-tabs > .nav-item > .nav-link')


                            let curvesTabTitle = document.getElementById('characteristics-nav-tab');
                            curvesTabTitle.innerHTML = this.__('lang.global.product.tabs.curveswithop')

                            allTabPanes.forEach((tabPane) => {
                                tabPane.classList.remove('active')
                            });

                            allLinksTabs.forEach((linkTab) => {
                                linkTab.classList.remove('active');
                            })

                            curvesTab.classList.add('active');
                            curvesTabPane.classList.add('active');

                        }

                        //this.getProductCurves()
                        this.$refs.highcharttab.getProductCurves()
                        //this.$refs.prodcurves.click();
                        //this.$refs.productdetail.getProductCurves()
                        //setTimeout(this.getProductCurves(), 50000);
                        /* setTimeout(() => {
                         this.$refs.prodcurves.click();

                     },4000)
                      */
                    }
                //},50000)

            },
            createPdf(){
                this.$parent.$refs.productdesc.createPdf()

            },
            /*Zip:*/
            createZip() {
                 this.$parent.$refs.productdesc.createZip()
            },
            /*:Zip*/


            },
          created() {
            //--this.getProductAcoustics()
          },
          mounted() {
             // this.$refs.prodcurves.click();
              //this.loaded();
              //this.getProductCurves();

          },

    }


</script>
<style>
.table.b-table.techdata.b-table-stacked>tbody>tr>[data-label]::before {
  content: attr(data-label);
  width: 40%;
  float: left;
  text-align: left;
  overflow-wrap: break-word;
  font-weight: normal;
  font-style: normal;
  padding: 0.2rem calc(1rem / 3) 0 0;
  margin: 0;
  border-right: 1px solid #e8e8e8;
  font-size: 80%;
}

.table.b-table.techdata.table-striped.b-table-stacked>tbody>tr:nth-child(odd)>td,
.table.b-table.techdata.table-striped.b-table-stacked>tbody>tr:nth-child(odd)>th {
  background-color: #fff;

}
/*
.table.b-table.techdata.table-striped.b-table-stacked>tbody>tr:nth-child(even)>td,
.table.b-table.techdata.table-striped.b-table-stacked>tbody>tr:nth-child(even)>th {
  background-color: #ECEFF1;
  color: white;
} */

.table.b-table.techdata.b-table-stacked>caption,
.table.b-table.b-table-stacked>tbody,
.table.b-table.b-table-stacked>tbody>tr,
.table.b-table.b-table-stacked>tbody>tr>td,
.table.b-table.b-table-stacked>tbody>tr>th {
 /*  line-height: 0.5rem; */
  padding-left: 0
}

[id^="items_"] > tbody > tr > td:first-of-type {
  padding-bottom: 0.25rem;
  padding-top: 0.25rem;
}

.iframe-container {
  width: 100%;
  height: 100%;
}
.footwhite{
    background-color: #ffffff;
}

.footgrey{
     background-color: #f5f5f5;
}

</style>

